function initCustom() {
  theme.Search = function () {
	var selectors = {
		search: ".search",
		searchSubmit: ".search__submit",
		searchInput: ".search__input",
		siteHeader: ".site-header",
		siteHeaderSearchToggle: ".site-header__search-toggle",
		siteHeaderSearch: ".site-header__search",
		searchDrawer: ".search-bar",
		searchDrawerInput: ".search-bar__input",
		searchHeader: ".search-header",
		searchHeaderInput: ".search-header__input",
		searchHeaderSubmit: ".search-header__submit",
		searchResultSubmit: "#SearchResultSubmit",
		searchResultInput: "#SearchInput",
		searchResultMessage: "[data-search-error-message]",
		mobileNavWrapper: ".mobile-nav-wrapper"
	};
	var classes = {
		focus: "search--focus",
		hidden: "hide",
		mobileNavIsOpen: "js-menu--is-open",
		searchTemplate: "template-search"
	};

	function init() {
		if (!$(selectors.siteHeader).length) {
			return
		}
		this.$searchResultInput = $(selectors.searchResultInput);
		this.$searchErrorMessage = $(selectors.searchResultMessage);
		initDrawer();
		var isSearchPage = slate.utils.getParameterByName("q") !== null && $("body").hasClass(classes.searchTemplate);
		if (isSearchPage) {
			validateSearchResultForm.call(this)
		}
		$(selectors.searchResultSubmit).on("click", validateSearchResultForm.bind(this));
		$(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on("focus blur", function () {
			$(selectors.searchHeader).toggleClass(classes.focus)
		});
		$(selectors.siteHeaderSearchToggle).on("click", function () {
			var searchHeight = $(selectors.siteHeader).outerHeight();
			var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;
			$(selectors.searchDrawer).css({
				height: searchHeight + "px",
				top: searchOffset + "px"
			})
		})
	}

	function initDrawer() {
		$("#PageContainer").addClass("drawer-page-content");
		$(".js-drawer-open-top").attr("aria-controls", "SearchDrawer").attr("aria-expanded", "false").attr("aria-haspopup", "dialog");
		theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
			onDrawerOpen: searchDrawerFocus,
			onDrawerClose: searchDrawerFocusClose
		})
	}

	function searchDrawerFocus() {
		searchFocus($(selectors.searchDrawerInput));
		if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
			theme.MobileNav.closeMobileNav()
		}
	}

	function searchFocus($el) {
		$el.focus();
		$el[0].setSelectionRange(0, $el[0].value.length)
	}

	function searchDrawerFocusClose() {
		$(selectors.siteHeaderSearchToggle).focus()
	}

	function hideErrorMessage() {
		this.$searchErrorMessage.addClass(classes.hidden);
		this.$searchResultInput.removeAttr("aria-describedby").removeAttr("aria-invalid")
	}

	function showErrorMessage() {
		this.$searchErrorMessage.removeClass(classes.hidden);
		this.$searchResultInput.attr("aria-describedby", "error-search-form").attr("aria-invalid", true)
	}

	function validateSearchResultForm(evt) {
		var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;
		if (!isInputValueEmpty) {
			hideErrorMessage.call(this);
			return
		}
		if (typeof evt !== "undefined") {
			evt.preventDefault()
		}
		searchFocus(this.$searchResultInput);
		showErrorMessage.call(this)
	}
	return {
		init: init
	}
}();
(function () {
	var selectors = {
		backButton: ".return-link"
	};
	var $backButton = $(selectors.backButton);
	if (!document.referrer || !$backButton.length || !window.history.length) {
		return
	}
	$backButton.one("click", function (evt) {
		evt.preventDefault();
		var referrerDomain = urlDomain(document.referrer);
		var shopDomain = urlDomain(window.location.href);
		if (shopDomain === referrerDomain) {
			history.back()
		}
		return false
	});

	function urlDomain(url) {
		var anchor = document.createElement("a");
		anchor.ref = url;
		return anchor.hostname
	}
})();
theme.Slideshow = function () {
	this.$slideshow = null;
	var classes = {
		slideshow: "slideshow",
		slickActiveMobile: "slick-active-mobile",
		controlsHover: "slideshow__controls--hover",
		isPaused: "is-paused"
	};
	var selectors = {
		section: ".shopify-section",
		wrapper: "#SlideshowWrapper-",
		slides: ".slideshow__slide",
		textWrapperMobile: ".slideshow__text-wrap--mobile",
		textContentMobile: ".slideshow__text-content--mobile",
		controls: ".slideshow__controls",
		pauseButton: ".slideshow__pause",
		dots: ".slick-dots",
		arrows: ".slideshow__arrows",
		arrowsMobile: ".slideshow__arrows--mobile",
		arrowLeft: ".slideshow__arrow-left",
		arrowRight: ".slideshow__arrow-right"
	};

	function slideshow(el, sectionId) {
		var $slideshow = this.$slideshow = $(el);
		this.adaptHeight = this.$slideshow.data("adapt-height");
		this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
		this.$section = this.$wrapper.closest(selectors.section);
		this.$controls = this.$wrapper.find(selectors.controls);
		this.$arrows = this.$section.find(selectors.arrows);
		this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
		this.$pause = this.$controls.find(selectors.pauseButton);
		this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
		this.autorotate = this.$slideshow.data("autorotate");
		var autoplaySpeed = this.$slideshow.data("speed");
		var loadSlideA11yString = this.$slideshow.data("slide-nav-a11y");
		this.settings = {
			accessibility: true,
			arrows: false,
			dots: true,
			fade: true,
			draggable: true,
			touchThreshold: 20,
			autoplay: this.autorotate,
			autoplaySpeed: autoplaySpeed,
			appendDots: this.$arrows,
			customPaging: function (slick, index) {
				return '<a href="' + selectors.wrapper + sectionId + '" aria-label="' + loadSlideA11yString.replace("[slide_number]", index + 1) + '" data-slide-number="' + index + '"></a>'
			}
		};
		this.$slideshow.on("beforeChange", beforeChange.bind(this));
		this.$slideshow.on("init", slideshowA11ySetup.bind(this));
		this.$slideshow.on("init", function () {
			this.$mobileDots.find("li:first-of-type").addClass(classes.slickActiveMobile);
			this.showMobileText(0)
		}.bind(this));
		if (this.autorotate) {
			$(document).scroll($.debounce(250, function () {
				if (this.$arrowsMobile.offset().top + this.$arrowsMobile.outerHeight() < window.pageYOffset) {
					$slideshow.slick("slickPause")
				} else if (!this.$pause.hasClass(classes.isPaused)) {
					$slideshow.slick("slickPlay")
				}
			}.bind(this)))
		}
		if (this.adaptHeight) {
			this.setSlideshowHeight();
			$(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)))
		}
		this.$slideshow.slick(this.settings);
		slideshowPostInitA11ySetup.bind(this)();
		this.$arrows.find(selectors.arrowLeft).on("click", function () {
			$slideshow.slick("slickPrev")
		});
		this.$arrows.find(selectors.arrowRight).on("click", function () {
			$slideshow.slick("slickNext")
		});
		this.$pause.on("click", this.togglePause.bind(this))
	}

	function slideshowA11ySetup(event, obj) {
		var $slider = obj.$slider;
		var $list = obj.$list;
		this.$dots = this.$section.find(selectors.dots);
		this.$mobileDots = this.$dots.eq(1);
		$list.removeAttr("aria-live");
		this.$wrapper.on("keyup", keyboardNavigation.bind(this));
		this.$controls.on("keyup", keyboardNavigation.bind(this));
		this.$textWrapperMobile.on("keyup", keyboardNavigation.bind(this));
		this.$wrapper.on("focusin", function (evt) {
			if (!this.$wrapper.has(evt.target).length) {
				return
			}
			$list.attr("aria-live", "polite");
			if (this.autorotate) {
				$slider.slick("slickPause")
			}
		}.bind(this)).on("focusout", function (evt) {
			if (!this.$wrapper.has(evt.target).length) {
				return
			}
			$list.removeAttr("aria-live");
			if (this.autorotate) {
				if (!this.$pause.is(".is-paused")) {
					$slider.slick("slickPlay")
				}
			}
		}.bind(this));
		if (this.$dots) {
			this.$dots.find("a").each(function () {
				var $dot = $(this);
				$dot.on("click keyup", function (evt) {
					if (evt.type === "keyup" && evt.which !== slate.utils.keyboardKeys.ENTER) return;
					evt.preventDefault();
					var slideNumber = $(evt.target).data("slide-number");
					$slider.attr("tabindex", -1).slick("slickGoTo", slideNumber);
					if (evt.type === "keyup") {
						$slider.focus()
					}
				})
			}).eq(0).attr("aria-current", "true")
		}
		this.$controls.on("focusin", highlightControls.bind(this)).on("focusout", unhighlightControls.bind(this))
	}

	function slideshowPostInitA11ySetup() {
		var $slides = this.$slideshow.find(selectors.slides);
		$slides.removeAttr("role").removeAttr("aria-labelledby");
		this.$dots.removeAttr("role").find("li").removeAttr("role").removeAttr("aria-selected").each(function () {
			var $dot = $(this);
			var ariaControls = $dot.attr("aria-controls");
			$dot.removeAttr("aria-controls").find("a").attr("aria-controls", ariaControls)
		})
	}

	function beforeChange(event, slick, currentSlide, nextSlide) {
		var $dotLinks = this.$dots.find("a");
		var $mobileDotLinks = this.$mobileDots.find("li");
		$dotLinks.removeAttr("aria-current").eq(nextSlide).attr("aria-current", "true");
		$mobileDotLinks.removeClass(classes.slickActiveMobile).eq(nextSlide).addClass(classes.slickActiveMobile);
		this.showMobileText(nextSlide)
	}

	function keyboardNavigation() {
		if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
			this.$slideshow.slick("slickPrev")
		}
		if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
			this.$slideshow.slick("slickNext")
		}
	}

	function highlightControls() {
		this.$controls.addClass(classes.controlsHover)
	}

	function unhighlightControls() {
		this.$controls.removeClass(classes.controlsHover)
	}
	slideshow.prototype.togglePause = function () {
		var slideshowSelector = getSlideshowId(this.$pause);
		if (this.$pause.hasClass(classes.isPaused)) {
			this.$pause.removeClass(classes.isPaused).attr("aria-pressed", "false");
			if (this.autorotate) {
				$(slideshowSelector).slick("slickPlay")
			}
		} else {
			this.$pause.addClass(classes.isPaused).attr("aria-pressed", "true");
			if (this.autorotate) {
				$(slideshowSelector).slick("slickPause")
			}
		}
	};
	slideshow.prototype.setSlideshowHeight = function () {
		var minAspectRatio = this.$slideshow.data("min-aspect-ratio");
		this.$slideshow.height($(document).width() / minAspectRatio)
	};
	slideshow.prototype.showMobileText = function (slideIndex) {
		var $allTextContent = this.$textWrapperMobile.find(selectors.textContentMobile);
		var currentTextContentSelector = selectors.textContentMobile + "-" + slideIndex;
		var $currentTextContent = this.$textWrapperMobile.find(currentTextContentSelector);
		if (!$currentTextContent.length && this.$slideshow.find(selectors.slides).length === 1) {
			this.$textWrapperMobile.hide()
		} else {
			this.$textWrapperMobile.show()
		}
		$allTextContent.hide();
		$currentTextContent.show()
	};

	function getSlideshowId($el) {
		return "#Slideshow-" + $el.data("id")
	}
	return slideshow
}();

function onYouTubeIframeAPIReady() {
	theme.Video.loadVideos()
}
theme.Video = function () {
	var autoplayCheckComplete = false;
	var playOnClickChecked = false;
	var playOnClick = false;
	var youtubeLoaded = false;
	var videos = {};
	var videoPlayers = [];
	var videoOptions = {
		ratio: 16 / 9,
		scrollAnimationDuration: 400,
		playerVars: {
			iv_load_policy: 3,
			modestbranding: 1,
			autoplay: 0,
			controls: 0,
			wmode: "opaque",
			branding: 0,
			autohide: 0,
			rel: 0
		},
		events: {
			onReady: onPlayerReady,
			onStateChange: onPlayerChange
		}
	};
	var classes = {
		playing: "video-is-playing",
		paused: "video-is-paused",
		loading: "video-is-loading",
		loaded: "video-is-loaded",
		backgroundVideoWrapper: "video-background-wrapper",
		videoWithImage: "video--image_with_play",
		backgroundVideo: "video--background",
		userPaused: "is-paused",
		supportsAutoplay: "autoplay",
		supportsNoAutoplay: "no-autoplay",
		wrapperMinHeight: "video-section-wrapper--min-height"
	};
	var selectors = {
		section: ".video-section",
		videoWrapper: ".video-section-wrapper",
		playVideoBtn: ".video-control__play",
		closeVideoBtn: ".video-control__close-wrapper",
		pauseVideoBtn: ".video__pause"
	};

	function init($video) {
		if (!$video.length) {
			return
		}
		videos[$video.attr("id")] = {
			id: $video.attr("id"),
			videoId: $video.data("id"),
			type: $video.data("type"),
			status: $video.data("type") === "image_with_play" ? "closed" : "background",
			$video: $video,
			$videoWrapper: $video.closest(selectors.videoWrapper),
			$section: $video.closest(selectors.section),
			controls: $video.data("type") === "background" ? 0 : 1
		};
		if (!youtubeLoaded) {
			var tag = document.createElement("script");
			tag.src = "https://www.youtube.com/iframe_api";
			var firstScriptTag = document.getElementsByTagName("script")[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
		}
		playOnClickCheck()
	}

	function customPlayVideo(playerId) {
		if (!playOnClickChecked && !playOnClick) {
			return
		}
		if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
			privatePlayVideo(playerId)
		}
	}

	function pauseVideo(playerId) {
		if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === "function") {
			videoPlayers[playerId].pauseVideo()
		}
	}

	function loadVideos() {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				createPlayer(key)
			}
		}
		initEvents();
		youtubeLoaded = true
	}

	function editorLoadVideo(key) {
		if (!youtubeLoaded) {
			return
		}
		createPlayer(key);
		initEvents()
	}

	function privatePlayVideo(id, clicked) {
		var videoData = videos[id];
		var player = videoPlayers[id];
		var $videoWrapper = videoData.$videoWrapper;
		if (playOnClick) {
			setAsPlaying(videoData)
		} else if (clicked || autoplayCheckComplete) {
			$videoWrapper.removeClass(classes.loading);
			setAsPlaying(videoData);
			player.playVideo();
			return
		} else {
			player.playVideo()
		}
	}

	function setAutoplaySupport(supported) {
		var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
		$(document.documentElement).removeClass(classes.supportsAutoplay).removeClass(classes.supportsNoAutoplay).addClass(supportClass);
		if (!supported) {
			playOnClick = true
		}
		autoplayCheckComplete = true
	}

	function playOnClickCheck() {
		if (playOnClickChecked) {
			return
		}
		if (isMobile()) {
			playOnClick = true
		}
		if (playOnClick) {
			setAutoplaySupport(false)
		}
		playOnClickChecked = true
	}

	function onPlayerReady(evt) {
		evt.target.setPlaybackQuality("hd1080");
		var videoData = getVideoOptions(evt);
		playOnClickCheck();
		$("#" + videoData.id).attr("tabindex", "-1");
		sizeBackgroundVideos();
		if (videoData.type === "background") {
			evt.target.mute();
			privatePlayVideo(videoData.id)
		}
		videoData.$videoWrapper.addClass(classes.loaded)
	}

	function onPlayerChange(evt) {
		var videoData = getVideoOptions(evt);
		if (videoData.status === "background" && !isMobile() && !autoplayCheckComplete && (evt.data === YT.PlayerState.PLAYING || evt.data === YT.PlayerState.BUFFERING)) {
			setAutoplaySupport(true);
			autoplayCheckComplete = true;
			videoData.$videoWrapper.removeClass(classes.loading)
		}
		switch (evt.data) {
			case YT.PlayerState.ENDED:
				setAsFinished(videoData);
				break;
			case YT.PlayerState.PAUSED:
				setTimeout(function () {
					if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
						setAsPaused(videoData)
					}
				}, 200);
				break
		}
	}

	function setAsFinished(videoData) {
		switch (videoData.type) {
			case "background":
				videoPlayers[videoData.id].seekTo(0);
				break;
			case "image_with_play":
				closeVideo(videoData.id);
				toggleExpandVideo(videoData.id, false);
				break
		}
	}

	function setAsPlaying(videoData) {
		var $videoWrapper = videoData.$videoWrapper;
		var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);
		$videoWrapper.removeClass(classes.loading);
		if ($pauseButton.hasClass(classes.userPaused)) {
			$pauseButton.removeClass(classes.userPaused)
		}
		if (videoData.status === "background") {
			return
		}
		$("#" + videoData.id).attr("tabindex", "0");
		if (videoData.type === "image_with_play") {
			$videoWrapper.removeClass(classes.paused).addClass(classes.playing)
		}
		setTimeout(function () {
			$videoWrapper.find(selectors.closeVideoBtn).focus()
		}, videoOptions.scrollAnimationDuration)
	}

	function setAsPaused(videoData) {
		var $videoWrapper = videoData.$videoWrapper;
		if (videoData.type === "image_with_play") {
			if (videoData.status === "closed") {
				$videoWrapper.removeClass(classes.paused)
			} else {
				$videoWrapper.addClass(classes.paused)
			}
		}
		$videoWrapper.removeClass(classes.playing)
	}

	function closeVideo(playerId) {
		var videoData = videos[playerId];
		var $videoWrapper = videoData.$videoWrapper;
		var classesToRemove = [classes.paused, classes.playing].join(" ");
		if (isMobile()) {
			$videoWrapper.removeAttr("style")
		}
		$("#" + videoData.id).attr("tabindex", "-1");
		videoData.status = "closed";
		switch (videoData.type) {
			case "image_with_play":
				videoPlayers[playerId].stopVideo();
				setAsPaused(videoData);
				break;
			case "background":
				videoPlayers[playerId].mute();
				setBackgroundVideo(playerId);
				break
		}
		$videoWrapper.removeClass(classesToRemove)
	}

	function getVideoOptions(evt) {
		return videos[evt.target.a.id]
	}

	function toggleExpandVideo(playerId, expand) {
		var video = videos[playerId];
		var elementTop = video.$videoWrapper.offset().top;
		var offset = 0;
		var newHeight = 0;
		if (isMobile()) {
			video.$videoWrapper.parent().toggleClass("page-width", !expand)
		}
		if (expand) {
			if (isMobile()) {
				newHeight = $(window).width() / videoOptions.ratio
			} else {
				newHeight = video.$videoWrapper.width() / videoOptions.ratio
			}
			offset = ($(window).height() - newHeight) / 2;
			video.$videoWrapper.removeClass(classes.wrapperMinHeight).animate({
				height: newHeight
			}, 600);
			if (!(isMobile() && Shopify.designMode)) {
				$("html, body").animate({
					scrollTop: elementTop - offset
				}, videoOptions.scrollAnimationDuration)
			}
		} else {
			if (isMobile()) {
				newHeight = video.$videoWrapper.data("mobile-height")
			} else {
				newHeight = video.$videoWrapper.data("desktop-height")
			}
			video.$videoWrapper.height(video.$videoWrapper.width() / videoOptions.ratio).animate({
				height: newHeight
			}, 600);
			setTimeout(function () {
				video.$videoWrapper.addClass(classes.wrapperMinHeight)
			}, 600)
		}
	}

	function togglePause(playerId) {
		var $pauseButton = videos[playerId].$videoWrapper.find(selectors.pauseVideoBtn);
		if ($pauseButton.hasClass(classes.userPaused)) {
			$pauseButton.removeClass(classes.userPaused);
			customPlayVideo(playerId)
		} else {
			$pauseButton.addClass(classes.userPaused);
			pauseVideo(playerId)
		}
	}

	function startVideoOnClick(playerId) {
		var video = videos[playerId];
		video.$videoWrapper.addClass(classes.loading);
		video.$videoWrapper.attr("style", "height: " + video.$videoWrapper.height() + "px");
		video.status = "open";
		switch (video.type) {
			case "image_with_play":
				privatePlayVideo(playerId, true);
				break;
			case "background":
				unsetBackgroundVideo(playerId, video);
				videoPlayers[playerId].unMute();
				privatePlayVideo(playerId, true);
				break
		}
		toggleExpandVideo(playerId, true);
		$(document).on("keydown.videoPlayer", function (evt) {
			var playerId = $(document.activeElement).data("controls");
			if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
				return
			}
			closeVideo(playerId);
			toggleExpandVideo(playerId, false)
		})
	}

	function sizeBackgroundVideos() {
		$("." + classes.backgroundVideo).each(function (index, el) {
			sizeBackgroundVideo($(el))
		})
	}

	function sizeBackgroundVideo($videoPlayer) {
		if (!youtubeLoaded) {
			return
		}
		if (isMobile()) {
			$videoPlayer.removeAttr("style")
		} else {
			var $videoWrapper = $videoPlayer.closest(selectors.videoWrapper);
			var videoWidth = $videoWrapper.width();
			var playerWidth = $videoPlayer.width();
			var desktopHeight = $videoWrapper.data("desktop-height");
			if (videoWidth / videoOptions.ratio < desktopHeight) {
				playerWidth = Math.ceil(desktopHeight * videoOptions.ratio);
				$videoPlayer.width(playerWidth).height(desktopHeight).css({
					left: (videoWidth - playerWidth) / 2,
					top: 0
				})
			} else {
				desktopHeight = Math.ceil(videoWidth / videoOptions.ratio);
				$videoPlayer.width(videoWidth).height(desktopHeight).css({
					left: 0,
					top: (desktopHeight - desktopHeight) / 2
				})
			}
			$videoPlayer.prepareTransition();
			$videoWrapper.addClass(classes.loaded)
		}
	}

	function unsetBackgroundVideo(playerId) {
		$("#" + playerId).removeClass(classes.backgroundVideo).addClass(classes.videoWithImage);
		setTimeout(function () {
			$("#" + playerId).removeAttr("style")
		}, 600);
		videos[playerId].$videoWrapper.removeClass(classes.backgroundVideoWrapper).addClass(classes.playing);
		videos[playerId].status = "open"
	}

	function setBackgroundVideo(playerId) {
		$("#" + playerId).removeClass(classes.videoWithImage).addClass(classes.backgroundVideo);
		videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper);
		videos[playerId].status = "background";
		sizeBackgroundVideo($("#" + playerId))
	}

	function isMobile() {
		return $(window).width() < 750 || window.mobileCheck()
	}

	function initEvents() {
		$(document).on("click.videoPlayer", selectors.playVideoBtn, function (evt) {
			var playerId = $(evt.currentTarget).data("controls");
			startVideoOnClick(playerId)
		});
		$(document).on("click.videoPlayer", selectors.closeVideoBtn, function (evt) {
			var playerId = $(evt.currentTarget).data("controls");
			$(evt.currentTarget).blur();
			closeVideo(playerId);
			toggleExpandVideo(playerId, false)
		});
		$(document).on("click.videoPlayer", selectors.pauseVideoBtn, function (evt) {
			var playerId = $(evt.currentTarget).data("controls");
			togglePause(playerId)
		});
		$(window).on("resize.videoPlayer", $.debounce(200, function () {
			if (!youtubeLoaded) return;
			var key;
			var fullscreen = window.innerHeight === screen.height;
			sizeBackgroundVideos();
			if (isMobile()) {
				for (key in videos) {
					if (videos.hasOwnProperty(key)) {
						if (videos[key].$videoWrapper.hasClass(classes.playing)) {
							if (!fullscreen) {
								pauseVideo(key);
								setAsPaused(videos[key])
							}
						}
						videos[key].$videoWrapper.height($(document).width() / videoOptions.ratio)
					}
				}
				setAutoplaySupport(false)
			} else {
				setAutoplaySupport(true);
				for (key in videos) {
					if (videos[key].$videoWrapper.find("." + classes.videoWithImage).length) {
						continue
					}
					videoPlayers[key].playVideo();
					setAsPlaying(videos[key])
				}
			}
		}));
		$(window).on("scroll.videoPlayer", $.debounce(50, function () {
			if (!youtubeLoaded) return;
			for (var key in videos) {
				if (videos.hasOwnProperty(key)) {
					var $videoWrapper = videos[key].$videoWrapper;
					if ($videoWrapper.hasClass(classes.playing) && ($videoWrapper.offset().top + $videoWrapper.height() * .75 < $(window).scrollTop() || $videoWrapper.offset().top + $videoWrapper.height() * .25 > $(window).scrollTop() + $(window).height())) {
						closeVideo(key);
						toggleExpandVideo(key, false)
					}
				}
			}
		}))
	}

	function createPlayer(key) {
		var args = $.extend({}, videoOptions, videos[key]);
		args.playerVars.controls = args.controls;
		videoPlayers[key] = new YT.Player(key, args)
	}

	function removeEvents() {
		$(document).off(".videoPlayer");
		$(window).off(".videoPlayer")
	}
	return {
		init: init,
		editorLoadVideo: editorLoadVideo,
		loadVideos: loadVideos,
		playVideo: customPlayVideo,
		pauseVideo: pauseVideo,
		removeEvents: removeEvents
	}
}();
window.theme = window.theme || {};
theme.FormStatus = function () {
	var selectors = {
		statusMessage: "[data-form-status]"
	};

	function init() {
		this.$statusMessage = $(selectors.statusMessage);
		if (!this.$statusMessage) return;
		this.$statusMessage.attr("tabindex", -1).focus();
		this.$statusMessage.on("blur", handleBlur.bind(this))
	}

	function handleBlur() {
		this.$statusMessage.removeAttr("tabindex")
	}
	return {
		init: init
	}
}();
theme.Hero = function () {
	var classes = {
		indexSectionFlush: "index-section--flush"
	};
	var selectors = {
		heroFixedWidthContent: ".hero-fixed-width__content",
		heroFixedWidthImage: ".hero-fixed-width__image"
	};

	function hero(el, sectionId) {
		this.$hero = $(el);
		this.layout = this.$hero.data("layout");
		var $parentSection = $("#shopify-section-" + sectionId);
		var $heroContent = $parentSection.find(selectors.heroFixedWidthContent);
		var $heroImage = $parentSection.find(selectors.heroFixedWidthImage);
		if (this.layout !== "fixed_width") {
			return
		}
		$parentSection.removeClass(classes.indexSectionFlush);
		heroFixedHeight();
		$(window).resize($.debounce(50, function () {
			heroFixedHeight()
		}));

		function heroFixedHeight() {
			var contentHeight = $heroContent.height() + 50;
			var imageHeight = $heroImage.height();
			if (contentHeight > imageHeight) {
				$heroImage.css("min-height", contentHeight)
			}
		}
	}
	return hero
}();
(function () {
	var $filterBy = $("#BlogTagFilter");
	if (!$filterBy.length) {
		return
	}
	$filterBy.on("change", function () {
		location.href = $(this).val()
	})
})();
window.theme = theme || {};
theme.customerTemplates = function () {
	var selectors = {
		RecoverHeading: "#RecoverHeading",
		RecoverEmail: "#RecoverEmail",
		LoginHeading: "#LoginHeading"
	};

	function initEventListeners() {
		this.$RecoverHeading = $(selectors.RecoverHeading);
		this.$RecoverEmail = $(selectors.RecoverEmail);
		this.$LoginHeading = $(selectors.LoginHeading);
		$("#RecoverPassword").on("click", function (evt) {
			evt.preventDefault();
			showRecoverPasswordForm();
			this.$RecoverHeading.attr("tabindex", "-1").focus()
		}.bind(this));
		$("#HideRecoverPasswordLink").on("click", function (evt) {
			evt.preventDefault();
			hideRecoverPasswordForm();
			this.$LoginHeading.attr("tabindex", "-1").focus()
		}.bind(this));
		this.$RecoverHeading.on("blur", function () {
			$(this).removeAttr("tabindex")
		});
		this.$LoginHeading.on("blur", function () {
			$(this).removeAttr("tabindex")
		})
	}

	function showRecoverPasswordForm() {
		$("#RecoverPasswordForm").removeClass("hide");
		$("#CustomerLoginForm").addClass("hide");
		if (this.$RecoverEmail.attr("aria-invalid") === "true") {
			this.$RecoverEmail.focus()
		}
	}

	function hideRecoverPasswordForm() {
		$("#RecoverPasswordForm").addClass("hide");
		$("#CustomerLoginForm").removeClass("hide")
	}

	function resetPasswordSuccess() {
		var $formState = $(".reset-password-success");
		if (!$formState.length) {
			return
		}
		$("#ResetSuccess").removeClass("hide").focus()
	}

	function customerAddressForm() {
		var $newAddressForm = $("#AddressNewForm");
		var $newAddressFormButton = $("#AddressNewButton");
		if (!$newAddressForm.length) {
			return
		}
		if (Shopify) {
			new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
				hideElement: "AddressProvinceContainerNew"
			})
		}
		$(".address-country-option").each(function () {
			var formId = $(this).data("form-id");
			var countrySelector = "AddressCountry_" + formId;
			var provinceSelector = "AddressProvince_" + formId;
			var containerSelector = "AddressProvinceContainer_" + formId;
			new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
				hideElement: containerSelector
			})
		});
		$(".address-new-toggle").on("click", function () {
			var isExpanded = $newAddressFormButton.attr("aria-expanded") === "true";
			$newAddressForm.toggleClass("hide");
			$newAddressFormButton.attr("aria-expanded", !isExpanded).focus()
		});
		$(".address-edit-toggle").on("click", function () {
			var formId = $(this).data("form-id");
			var $editButton = $("#EditFormButton_" + formId);
			var $editAddress = $("#EditAddress_" + formId);
			var isExpanded = $editButton.attr("aria-expanded") === "true";
			$editAddress.toggleClass("hide");
			$editButton.attr("aria-expanded", !isExpanded).focus()
		});
		$(".address-delete").on("click", function () {
			var $el = $(this);
			var target = $el.data("target");
			var confirmMessage = $el.data("confirm-message");
			if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
				Shopify.postLink(target, {
					parameters: {
						_method: "delete"
					}
				})
			}
		})
	}

	function checkUrlHash() {
		var hash = window.location.hash;
		if (hash === "#recover") {
			showRecoverPasswordForm.bind(this)()
		}
	}
	return {
		init: function () {
			initEventListeners();
			checkUrlHash();
			resetPasswordSuccess();
			customerAddressForm()
		}
	}
}();
window.theme = window.theme || {};
theme.Cart = function () {
	var selectors = {
		edit: ".js-edit-toggle",
		inputQty: ".cart__qty-input",
		thumbnails: ".cart__image",
		item: ".cart__row"
	};
	var config = {
		showClass: "cart__update--show",
		showEditClass: "cart__edit--active",
		cartNoCookies: "cart--no-cookies"
	};

	function Cart(container) {
		this.$container = $(container);
		this.$edit = $(selectors.edit, this.$container);
		this.$inputQuantities = $(selectors.inputQty, this.$container);
		this.$thumbnails = $(selectors.thumbnails, this.$container);
		if (!this.cookiesEnabled()) {
			this.$container.addClass(config.cartNoCookies)
		}
		this.$edit.on("click", this._onEditClick);
		this.$inputQuantities.on("change", this._handleInputQty);
		this.$thumbnails.css("cursor", "pointer");
		this.$thumbnails.on("click", this._handleThumbnailClick)
	}
	Cart.prototype = _.assignIn({}, Cart.prototype, {
		onUnload: function () {
			this.$edit.off("click", this._onEditClick)
		},
		_onEditClick: function (evt) {
			var $evtTarget = $(evt.target);
			var $updateLine = $("." + $evtTarget.data("target"));
			var isExpanded = $evtTarget.attr("aria-expanded") === "true";
			$evtTarget.toggleClass(config.showEditClass).attr("aria-expanded", !isExpanded);
			$updateLine.toggleClass(config.showClass)
		},
		_handleInputQty: function (evt) {
			var $input = $(evt.target);
			var value = $input.val();
			var itemKey = $input.data("quantity-item");
			var $itemQtyInputs = $("[data-quantity-item=" + itemKey + "]");
			$itemQtyInputs.val(value)
		},
		_handleThumbnailClick: function (evt) {
			var url = $(evt.target).data("item-url");
			if (!window.RevyUpsell || !window.RevyUpsell.isShowing) window.location.href = url
		},
		cookiesEnabled: function () {
			var cookieEnabled = navigator.cookieEnabled;
			if (!cookieEnabled) {
				document.cookie = "testcookie";
				cookieEnabled = document.cookie.indexOf("testcookie") !== -1
			}
			return cookieEnabled
		}
	});
	return Cart
}();
window.theme = window.theme || {};
theme.Filters = function () {
	var settings = {
		mediaQueryMediumUp: "screen and (min-width: 750px)"
	};
	var constants = {
		SORT_BY: "sort_by"
	};
	var selectors = {
		mainContent: "#MainContent",
		filterSelection: "#FilterTags",
		sortSelection: "#SortBy"
	};
	var data = {
		sortBy: "data-default-sortby"
	};

	function Filters(container) {
		var $container = this.$container = $(container);
		this.$filterSelect = $(selectors.filterSelection, $container);
		this.$sortSelect = $(selectors.sortSelection, $container);
		this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));
		this.defaultSort = this._getDefaultSortValue();
		this.$selects.removeClass("hidden");
		this.$filterSelect.on("change", this._onFilterChange.bind(this));
		this.$sortSelect.on("change", this._onSortChange.bind(this));
		this._initBreakpoints()
	}
	Filters.prototype = _.assignIn({}, Filters.prototype, {
		_initBreakpoints: function () {
			var self = this;
			enquire.register(settings.mediaQueryMediumUp, {
				match: function () {
					self._resizeSelect(self.$selects)
				}
			})
		},
		_onSortChange: function () {
			var sort = this._sortValue();
			var url = window.location.href.replace(window.location.search, "");
			var queryStringValue = slate.utils.getParameterByName("q");
			var query = queryStringValue !== null ? queryStringValue : "";
			if (sort.length) {
				var urlStripped = url.replace(window.location.hash, "");
				query = query !== "" ? "?q=" + query + "&" : "?";
				if (!window.RevyUpsell || !window.RevyUpsell.isShowing) window.location.href = urlStripped + query + sort + selectors.mainContent
			} else {
				if (!window.RevyUpsell || !window.RevyUpsell.isShowing) window.location.href = url
			}
		},
		_onFilterChange: function () {
			var filter = this._getFilterValue();
			var search = document.location.search.replace(/\?(page=\w+)?&?/, "");
			search = search !== "" ? "?" + search : "";
			document.location.href = filter + search + selectors.mainContent
		},
		_getFilterValue: function () {
			return this.$filterSelect.val()
		},
		_getSortValue: function () {
			return this.$sortSelect.val() || this.defaultSort
		},
		_getDefaultSortValue: function () {
			return this.$sortSelect.attr(data.sortBy)
		},
		_sortValue: function () {
			var sort = this._getSortValue();
			var query = "";
			if (sort !== this.defaultSort) {
				query = constants.SORT_BY + "=" + sort
			}
			return query
		},
		_resizeSelect: function ($selection) {
			$selection.each(function () {
				var $this = $(this);
				var arrowWidth = 10;
				var text = $this.find("option:selected").text();
				var $test = $("<span>").html(text);
				$test.appendTo("body");
				var width = $test.width();
				$test.remove();
				$this.width(width + arrowWidth)
			})
		},
		onUnload: function () {
			this.$filterSelect.off("change", this._onFilterChange);
			this.$sortSelect.off("change", this._onSortChange)
		}
	});
	return Filters
}();
window.theme = window.theme || {};
theme.HeaderSection = function () {
	function Header() {
		theme.Header.init();
		theme.MobileNav.init();
		theme.Search.init()
	}
	Header.prototype = _.assignIn({}, Header.prototype, {
		onUnload: function () {
			theme.Header.unload()
		}
	});
	return Header
}();
theme.Maps = function () {
	var config = {
		zoom: 14
	};
	var apiStatus = null;
	var mapsToLoad = [];
	var errors = {
		addressNoResults: theme.strings.addressNoResults,
		addressQueryLimit: theme.strings.addressQueryLimit,
		addressError: theme.strings.addressError,
		authError: theme.strings.authError
	};
	var selectors = {
		section: '[data-section-type="map"]',
		map: "[data-map]",
		mapOverlay: "[data-map-overlay]"
	};
	var classes = {
		mapError: "map-section--load-error",
		errorMsg: "map-section__error errors text-center"
	};
	window.gm_authFailure = function () {
		if (!Shopify.designMode) {
			return
		}
		$(selectors.section).addClass(classes.mapError);
		$(selectors.map).remove();
		$(selectors.mapOverlay).after('<div class="' + classes.errorMsg + '">' + theme.strings.authError + "</div>")
	};

	function Map(container) {
		this.$container = $(container);
		this.$map = this.$container.find(selectors.map);
		this.key = this.$map.data("api-key");
		if (typeof this.key === "undefined") {
			return
		}
		if (apiStatus === "loaded") {
			this.createMap()
		} else {
			mapsToLoad.push(this);
			if (apiStatus !== "loading") {
				apiStatus = "loading";
				if (typeof window.google === "undefined") {
					$.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
						apiStatus = "loaded";
						initAllMaps()
					})
				}
			}
		}
	}

	function initAllMaps() {
		$.each(mapsToLoad, function (index, instance) {
			instance.createMap()
		})
	}

	function geolocate($map) {
		var deferred = $.Deferred();
		var geocoder = new google.maps.Geocoder;
		var address = $map.data("address-setting");
		geocoder.geocode({
			address: address
		}, function (results, status) {
			if (status !== google.maps.GeocoderStatus.OK) {
				deferred.reject(status)
			}
			deferred.resolve(results)
		});
		return deferred
	}
	Map.prototype = _.assignIn({}, Map.prototype, {
		createMap: function () {
			var $map = this.$map;
			return geolocate($map).then(function (results) {
				var mapOptions = {
					zoom: config.zoom,
					center: results[0].geometry.location,
					draggable: false,
					clickableIcons: false,
					scrollwheel: false,
					disableDoubleClickZoom: true,
					disableDefaultUI: true
				};
				var map = this.map = new google.maps.Map($map[0], mapOptions);
				var center = this.center = map.getCenter();
				var marker = new google.maps.Marker({
					map: map,
					position: map.getCenter()
				});
				google.maps.event.addDomListener(window, "resize", $.debounce(250, function () {
					google.maps.event.trigger(map, "resize");
					map.setCenter(center);
					$map.removeAttr("style")
				}))
			}.bind(this)).fail(function () {
				var errorMessage;
				switch (status) {
					case "ZERO_RESULTS":
						errorMessage = errors.addressNoResults;
						break;
					case "OVER_QUERY_LIMIT":
						errorMessage = errors.addressQueryLimit;
						break;
					case "REQUEST_DENIED":
						errorMessage = errors.authError;
						break;
					default:
						errorMessage = errors.addressError;
						break
				}
				if (Shopify.designMode) {
					$map.parent().addClass(classes.mapError).html('<div class="' + classes.errorMsg + '">' + errorMessage + "</div>")
				}
			})
		},
		onUnload: function () {
			if (this.$map.length === 0) {
				return
			}
			google.maps.event.clearListeners(this.map, "resize")
		}
	});
	return Map
}();
theme.Product = function () {
	function Product(container) {
		var $container = this.$container = $(container);
		var sectionId = $container.attr("data-section-id");
		this.settings = {
			mediaQueryMediumUp: "screen and (min-width: 750px)",
			mediaQuerySmall: "screen and (max-width: 768px)",
			bpSmall: false,
			enableHistoryState: $container.data("enable-history-state") || false,
			namespace: ".slideshow-" + sectionId,
			sectionId: sectionId,
			sliderActive: false,
			zoomEnabled: false
		};
		this.selectors = {
			addToCart: "[data-add-to-cart]",
			addToCartText: "[data-add-to-cart-text]",
			quantity: "[data-quantity-input]",
			SKU: ".variant-sku",
			productStatus: "[data-product-status]",
			originalSelectorId: "#ProductSelect-" + sectionId,
			productForm: "[data-product-form]",
			errorMessage: "[data-error-message]",
			errorMessageWrapper: "[data-error-message-wrapper]",
			productImageWraps: ".product-single__photo",
			productThumbImages: ".product-single__thumbnail--" + sectionId,
			productThumbs: ".product-single__thumbnails-" + sectionId,
			productThumbListItem: ".product-single__thumbnails-item",
			productFeaturedImage: ".product-featured-img",
			productThumbsWrapper: ".thumbnails-wrapper",
			saleLabel: ".product-price__sale-label-" + sectionId,
			singleOptionSelector: ".single-option-selector-" + sectionId,
			shopifyPaymentButton: ".shopify-payment-button",
			priceContainer: "[data-price]",
			regularPrice: "[data-regular-price]",
			salePrice: "[data-sale-price]"
		};
		this.classes = {
			hidden: "hide",
			inputError: "input--error",
			productOnSale: "price--on-sale",
			productUnavailable: "price--unavailable",
			productFormErrorMessageWrapperHidden: "product-form__error-message-wrapper--hidden",
			activeClass: "active-thumb"
		};
		this.errors = {
			quantityMinumumMessage: theme.strings.quantityMinimumMessage
		};
		this.$quantityInput = $(this.selectors.quantity, $container);
		this.$errorMessageWrapper = $(this.selectors.errorMessageWrapper, $container);
		if (!$("#ProductJson-" + sectionId).html()) {
			return
		}
		this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + sectionId).innerHTML);
		this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass("js-zoom-enabled");
		this._initBreakpoints();
		this._stringOverrides();
		this._initVariants();
		this._initImageSwitch();
		this._initAddToCart();
		this._setActiveThumbnail()
	}
	Product.prototype = _.assignIn({}, Product.prototype, {
		_stringOverrides: function () {
			theme.productStrings = theme.productStrings || {};
			$.extend(theme.strings, theme.productStrings)
		},
		_initBreakpoints: function () {
			var self = this;
			enquire.register(this.settings.mediaQuerySmall, {
				match: function () {
					if ($(self.selectors.productThumbImages).length > 3) {
						self._initThumbnailSlider()
					}
					if (self.settings.zoomEnabled) {
						$(self.selectors.productImageWraps).each(function () {
							_destroyZoom(this)
						})
					}
					self.settings.bpSmall = true
				},
				unmatch: function () {
					if (self.settings.sliderActive) {
						self._destroyThumbnailSlider()
					}
					self.settings.bpSmall = false
				}
			});
			enquire.register(this.settings.mediaQueryMediumUp, {
				match: function () {
					if (self.settings.zoomEnabled) {
						$(self.selectors.productImageWraps).each(function () {
							_enableZoom(this)
						})
					}
				}
			})
		},
		_initVariants: function () {
			var options = {
				$container: this.$container,
				enableHistoryState: this.$container.data("enable-history-state") || false,
				singleOptionSelector: this.selectors.singleOptionSelector,
				originalSelectorId: this.selectors.originalSelectorId,
				product: this.productSingleObject
			};
			this.variants = new slate.Variants(options);
			this.$container.on("variantChange" + this.settings.namespace, this._updateAvailability.bind(this));
			this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this));
			this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this));
			this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
		},
		_initImageSwitch: function () {
			if (!$(this.selectors.productThumbImages).length) {
				return
			}
			var self = this;
			$(this.selectors.productThumbImages).on("click", function (evt) {
				evt.preventDefault();
				var $el = $(this);
				var imageId = $el.data("thumbnail-id");
				self._switchImage(imageId);
				self._setActiveThumbnail(imageId)
			}).on("keyup", self._handleImageFocus.bind(self))
		},
		_initAddToCart: function () {
			var self = this;
			$(self.selectors.productForm, self.$container).on("submit", function (evt) {
				evt.preventDefault();
				var $addToCart = $(self.selectors.addToCart, self.$container);
				var isInvalidQuantity = self.$quantityInput.val() <= 0;
				if ($addToCart.is("[disabled]")) return;
				if (isInvalidQuantity) {
					self._showErrorMessage(self.errors.quantityMinumumMessage)
				} else {
					var $data = $(self.selectors.productForm, self.$container);
					var redirectUrl = $data.data("product-form-redirect-url");
					self._addItemToCart($data, redirectUrl)
				}
			})
		},
		_addItemToCart: function (data, redirectUrl) {
			var self = this;
			var params = {
				url: "/cart/add.js",
				data: jQuery(data).serialize(),
				dataType: "json"
			};
			jQuery.post(params).done(function () {
				if (!window.RevyUpsell || !window.RevyUpsell.isShowing) window.location.href = redirectUrl
			}).fail(function (response) {
				self._showErrorMessage(response.responseJSON.description)
			})
		},
		_showErrorMessage: function (errorMessage) {
			$(this.selectors.errorMessage, this.$container).html(errorMessage);
			if (this.$quantityInput.length !== 0) {
				this.$quantityInput.addClass(this.classes.inputError)
			}
			this.$errorMessageWrapper.removeClass(this.classes.productFormErrorMessageWrapperHidden).attr("aria-hidden", true).removeAttr("aria-hidden")
		},
		_hideErrorMessage: function () {
			this.$errorMessageWrapper.addClass(this.classes.productFormErrorMessageWrapperHidden);
			if (this.$quantityInput.length !== 0) {
				this.$quantityInput.removeClass(this.classes.inputError)
			}
		},
		_setActiveThumbnail: function (imageId) {
			if (typeof imageId === "undefined") {
				imageId = $(this.selectors.productImageWraps + ":not(.hide)", this.$container).data("image-id")
			}
			var $thumbnailWrappers = $(this.selectors.productThumbListItem + ":not(.slick-cloned)", this.$container);
			var $activeThumbnail = $thumbnailWrappers.find(this.selectors.productThumbImages + "[data-thumbnail-id='" + imageId + "']");
			$(this.selectors.productThumbImages).removeClass(this.classes.activeClass).removeAttr("aria-current");
			$activeThumbnail.addClass(this.classes.activeClass);
			$activeThumbnail.attr("aria-current", true);
			if (!$thumbnailWrappers.hasClass("slick-slide")) {
				return
			}
			var slideIndex = $activeThumbnail.parent().data("slick-index");
			$(this.selectors.productThumbs).slick("slickGoTo", slideIndex, true)
		},
		_switchImage: function (imageId) {
			var $newImage = $(this.selectors.productImageWraps + "[data-image-id='" + imageId + "']", this.$container);
			var $otherImages = $(this.selectors.productImageWraps + ":not([data-image-id='" + imageId + "'])", this.$container);
			$newImage.removeClass(this.classes.hidden);
			$otherImages.addClass(this.classes.hidden)
		},
		_handleImageFocus: function (evt) {
			if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;
			$(this.selectors.productFeaturedImage + ":visible").focus()
		},
		_initThumbnailSlider: function () {
			var options = {
				slidesToShow: 4,
				slidesToScroll: 3,
				infinite: false,
				prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
				nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
				responsive: [{
					breakpoint: 321,
					settings: {
						slidesToShow: 3
					}
				}]
			};
			$(this.selectors.productThumbs).slick(options);
			$(this.selectors.productThumbsWrapper, this.$container).find(".slick-list").removeAttr("aria-live");
			$(this.selectors.productThumbsWrapper, this.$container).find(".slick-disabled").removeAttr("aria-disabled");
			this.settings.sliderActive = true
		},
		_destroyThumbnailSlider: function () {
			$(this.selectors.productThumbs).slick("unslick");
			this.settings.sliderActive = false;
			$(this.selectors.productThumbsWrapper, this.$container).find('[tabindex="-1"]').removeAttr("tabindex")
		},
		_liveRegionText: function (variant) {
			var liveRegionText = "[Availability] [Regular] [$$] [Sale] [$]";
			if (!variant) {
				liveRegionText = theme.strings.unavailable;
				return liveRegionText
			}
			var availability = variant.available ? "" : theme.strings.soldOut + ",";
			liveRegionText = liveRegionText.replace("[Availability]", availability);
			var regularLabel = "";
			var regularPrice = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
			var saleLabel = "";
			var salePrice = "";
			if (variant.compare_at_price > variant.price) {
				regularLabel = theme.strings.regularPrice;
				regularPrice = theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat) + ",";
				saleLabel = theme.strings.sale;
				salePrice = theme.Currency.formatMoney(variant.price, theme.moneyFormat)
			}
			liveRegionText = liveRegionText.replace("[Regular]", regularLabel).replace("[$$]", regularPrice).replace("[Sale]", saleLabel).replace("[$]", salePrice).trim();
			return liveRegionText
		},
		_updateLiveRegion: function (evt) {
			var variant = evt.variant;
			var liveRegion = this.container.querySelector(this.selectors.productStatus);
			liveRegion.textContent = this._liveRegionText(variant);
			liveRegion.setAttribute("aria-hidden", false);
			setTimeout(function () {
				liveRegion.setAttribute("aria-hidden", true)
			}, 1e3)
		},
		_updateAddToCart: function (evt) {
			var variant = evt.variant;
			/* START TRYNOW CODE */
			if (variant) {
				if (variant.available) {
					$(this.selectors.addToCart, this.$container).prop("disabled", false);
					if ($(".trynow-button").length > 0) {
						$(this.selectors.addToCart).css("background-color", "#000")
						$(this.selectors.addToCartText, this.$container).text("Add to cart");
						$(this.selectors.addToCart).css("letter-spacing", "0px !important");
						$(".trynow-button").css("background-color", "#fff");
						$(".trynow-button").css("letter-spacing", "0px !important");
						$(".trynow-button").text("Try at Home for Free");
					} else {
						$(this.selectors.addToCartText, this.$container).text(theme.strings.addToCart);
					}
					$(this.selectors.shopifyPaymentButton, this.$container).show()
				} else {
					$(this.selectors.addToCart, this.$container).prop("disabled", true);
					$(this.selectors.addToCartText, this.$container).text(theme.strings.soldOut);
					$(".trynow-button").text("Try at Home for Free");
					$(".trynow-container").hide();
					$(this.selectors.shopifyPaymentButton, this.$container).hide()
				}
			} else {
				$(this.selectors.addToCart, this.$container).prop("disabled", true);
				$(this.selectors.addToCartText, this.$container).text(theme.strings.unavailable);
				$(".trynow-button").text("Try at Home for Free");
				$(".trynow-container").hide();
				$(this.selectors.shopifyPaymentButton, this.$container).hide()
			}
			/* END TRYNOW CODE */
		},
		_updateAvailability: function (evt) {
			this._hideErrorMessage();
			this._updateAddToCart(evt);
			this._updateLiveRegion(evt);
			this._updatePrice(evt)
		},
		_updateImages: function (evt) {
			var variant = evt.variant;
			var imageId = variant.featured_image.id;
			this._switchImage(imageId);
			this._setActiveThumbnail(imageId)
		},
		_updatePrice: function (evt) {
			var variant = evt.variant;
			var $priceContainer = $(this.selectors.priceContainer, this.$container);
			var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
			var $salePrice = $(this.selectors.salePrice, $priceContainer);
			$priceContainer.removeClass(this.classes.productUnavailable).removeClass(this.classes.productOnSale).removeAttr("aria-hidden");
			$(".get_save_money").hide();
			$(".compare_price_ig").hide();
			if (!variant) {
				$priceContainer.addClass(this.classes.productUnavailable).attr("aria-hidden", true);
				return
			}
			if (variant.compare_at_price > variant.price) {
				$regularPrice.html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
				$salePrice.html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
				$(".compare_price_ig").attr("data-price", variant.price);
				$(".cmp_price").attr("data-compare", variant.compare_at_price);
				$priceContainer.addClass(this.classes.productOnSale);
				$(".get_save_money").show();
				$(".compare_price_ig").show()
			} else {
				$regularPrice.html(theme.Currency.formatMoney(variant.price, theme.moneyFormat))
			}
		},
		_updateSKU: function (evt) {
			var variant = evt.variant;
			$(this.selectors.SKU).html(variant.sku)
		},
		onUnload: function () {
			this.$container.off(this.settings.namespace)
		}
	});

	function _enableZoom(el) {
		var zoomUrl = $(el).data("zoom");
		$(el).zoom({
			url: zoomUrl
		})
	}

	function _destroyZoom(el) {
		$(el).trigger("zoom.destroy")
	}
	return Product
}();
theme.ProductRecommendations = function () {
	var selectors = {
		productCard: "[data-product-card]"
	};

	function ProductRecommendations(container) {
		this.$container = $(container);
		var productId = this.$container.data("productId");
		var recommendationsSectionUrl = "/recommendations/products?§ion_id=product-recommendations&product_id=" + productId + "&limit=4";
		$.get(recommendationsSectionUrl).then(function (section) {
			var recommendationsMarkup = $(section).html();
			if (recommendationsMarkup.trim() !== "") {
				this.$container.html(recommendationsMarkup);
				this.sendTrekkieEvent()
			}
		}.bind(this))
	}
	ProductRecommendations.prototype = _.assignIn({}, ProductRecommendations.prototype, {
		sendTrekkieEvent: function () {
			if (!window.ShopifyAnalytics || !window.ShopifyAnalytics.lib || !window.ShopifyAnalytics.lib.track) {
				return
			}
			var didPageJumpOccur = this.$container[0].getBoundingClientRect().top <= window.innerHeight;
			var numberOfRecommendationsDisplayed = this.$container.find(selectors.productCard).length;
			window.ShopifyAnalytics.lib.track("Product Recommendations Displayed", {
				theme: "debut",
				didPageJumpOccur: didPageJumpOccur,
				numberOfRecommendationsDisplayed: numberOfRecommendationsDisplayed
			})
		}
	});
	return ProductRecommendations
}();
theme.Quotes = function () {
	var config = {
		mediaQuerySmall: "screen and (max-width: 767px)",
		mediaQueryMediumUp: "screen and (min-width: 750px)",
		slideCount: 0
	};
	var defaults = {
		accessibility: true,
		arrows: false,
		dots: true,
		autoplay: false,
		touchThreshold: 20,
		slidesToShow: 3,
		slidesToScroll: 3
	};

	function Quotes(container) {
		var $container = this.$container = $(container);
		var sectionId = $container.attr("data-section-id");
		var wrapper = this.wrapper = ".quotes-wrapper";
		var slider = this.slider = "#Quotes-" + sectionId;
		var $slider = $(slider, wrapper);
		var sliderActive = false;
		var mobileOptions = $.extend({}, defaults, {
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true
		});
		config.slideCount = $slider.data("count");
		if (config.slideCount < defaults.slidesToShow) {
			defaults.slidesToShow = config.slideCount;
			defaults.slidesToScroll = config.slideCount
		}
		$slider.on("init", this.a11y.bind(this));
		enquire.register(config.mediaQuerySmall, {
			match: function () {
				initSlider($slider, mobileOptions)
			}
		});
		enquire.register(config.mediaQueryMediumUp, {
			match: function () {
				initSlider($slider, defaults)
			}
		});

		function initSlider(sliderObj, args) {
			if (sliderActive) {
				sliderObj.slick("unslick");
				sliderActive = false
			}
			sliderObj.slick(args);
			sliderActive = true
		}
	}
	Quotes.prototype = _.assignIn({}, Quotes.prototype, {
		onUnload: function () {
			enquire.unregister(config.mediaQuerySmall);
			enquire.unregister(config.mediaQueryMediumUp);
			$(this.slider, this.wrapper).slick("unslick")
		},
		onBlockSelect: function (evt) {
			var $slide = $(".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)");
			var slideIndex = $slide.data("slick-index");
			$(this.slider, this.wrapper).slick("slickGoTo", slideIndex)
		},
		a11y: function (event, obj) {
			var $list = obj.$list;
			var $wrapper = $(this.wrapper, this.$container);
			$list.removeAttr("aria-live");
			$wrapper.on("focusin", function (evt) {
				if ($wrapper.has(evt.target).length) {
					$list.attr("aria-live", "polite")
				}
			});
			$wrapper.on("focusout", function (evt) {
				if ($wrapper.has(evt.target).length) {
					$list.removeAttr("aria-live")
				}
			})
		}
	});
	return Quotes
}();
theme.slideshows = {};
theme.SlideshowSection = function () {
	function SlideshowSection(container) {
		var $container = this.$container = $(container);
		var sectionId = $container.attr("data-section-id");
		var slideshow = this.slideshow = "#Slideshow-" + sectionId;
		theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId)
	}
	return SlideshowSection
}();
theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
	onUnload: function () {
		delete theme.slideshows[this.slideshow]
	},
	onBlockSelect: function (evt) {
		var $slideshow = $(this.slideshow);
		var adaptHeight = $slideshow.data("adapt-height");
		if (adaptHeight) {
			theme.slideshows[this.slideshow].setSlideshowHeight()
		}
		var $slide = $(".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)");
		var slideIndex = $slide.data("slick-index");
		$slideshow.slick("slickGoTo", slideIndex).slick("slickPause")
	},
	onBlockDeselect: function () {
		$(this.slideshow).slick("slickPlay")
	}
});
theme.slideshows = {};
theme.VideoSection = function () {
	function VideoSection(container) {
		var $container = this.$container = $(container);
		$(".video", $container).each(function () {
			var $el = $(this);
			theme.Video.init($el);
			theme.Video.editorLoadVideo($el.attr("id"))
		})
	}
	return VideoSection
}();
theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
	onUnload: function () {
		theme.Video.removeEvents()
	}
});
theme.heros = {};
theme.HeroSection = function () {
	function HeroSection(container) {
		var $container = this.$container = $(container);
		var sectionId = $container.attr("data-section-id");
		var hero = "#Hero-" + sectionId;
		theme.heros[hero] = new theme.Hero(hero, sectionId)
	}
	return HeroSection
}();
$(document).ready(function () {
	var sections = new theme.Sections;
	sections.register("cart-template", theme.Cart);
	sections.register("product", theme.Product);
	sections.register("collection-template", theme.Filters);
	sections.register("product-template", theme.Product);
	sections.register("header-section", theme.HeaderSection);
	sections.register("map", theme.Maps);
	sections.register("slideshow-section", theme.SlideshowSection);
	sections.register("video-section", theme.VideoSection);
	sections.register("quotes", theme.Quotes);
	sections.register("hero-section", theme.HeroSection);
	sections.register("product-recommendations", theme.ProductRecommendations)
});
theme.init = function () {
	theme.customerTemplates.init();
	var tableSelectors = ".rte table," + ".custom__item-inner--html table";
	slate.rte.wrapTable({
		$tables: $(tableSelectors),
		tableWrapperClass: "scrollable-wrapper"
	});
	var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"],' + '.custom__item-inner--html iframe[src*="youtube.com/embed"],' + '.custom__item-inner--html iframe[src*="player.vimeo"]';
	slate.rte.wrapIframe({
		$iframes: $(iframeSelectors),
		iframeWrapperClass: "video-wrapper"
	});
	slate.a11y.pageLinkFocus($(window.location.hash));
	$(".in-page-link").on("click", function (evt) {
		slate.a11y.pageLinkFocus($(evt.currentTarget.hash))
	});
	$('a[href="#"]').on("click", function (evt) {
		evt.preventDefault()
	});
	slate.a11y.accessibleLinks({
		messages: {
			newWindow: theme.strings.newWindow,
			external: theme.strings.external,
			newWindowExternal: theme.strings.newWindowExternal
		},
		$links: $("a[href]:not([aria-describedby], .product-single__thumbnail)")
	});
	theme.FormStatus.init();
	var selectors = {
		image: "[data-image]",
		imagePlaceholder: "[data-image-placeholder]",
		imageWithPlaceholderWrapper: "[data-image-with-placeholder-wrapper]"
	};
	var classes = {
		hidden: "hide"
	};
	$(document).on("lazyloaded", function (e) {
		var $target = $(e.target);
		if (!$target.is(selectors.image)) {
			return
		}
		$target.closest(selectors.imageWithPlaceholderWrapper).find(selectors.imagePlaceholder).addClass(classes.hidden)
	});

	function onLoadHideLazysizesAnimation() {
		$(selectors.image + ".lazyloaded").closest(selectors.imageWithPlaceholderWrapper).find(selectors.imagePlaceholder).addClass(classes.hidden)
	}
	onLoadHideLazysizesAnimation()
};
$(theme.init);
! function (i) {
	"use strict";
	"function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery)
}(function (i) {
	"use strict";
	var e = window.Slick || {};
	(e = function () {
		var e = 0;
		return function (t, o) {
			var s, n = this;
			n.defaults = {
				accessibility: !0,
				adaptiveHeight: !1,
				appendArrows: i(t),
				appendDots: i(t),
				arrows: !0,
				asNavFor: null,
				prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
				nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
				autoplay: !1,
				autoplaySpeed: 3e3,
				centerMode: !1,
				centerPadding: "50px",
				cssEase: "ease",
				customPaging: function (e, t) {
					return i('<button type="button" />').text(t + 1)
				},
				dots: !1,
				dotsClass: "slick-dots",
				draggable: !0,
				easing: "linear",
				edgeFriction: .35,
				fade: !1,
				focusOnSelect: !1,
				focusOnChange: !1,
				infinite: !0,
				initialSlide: 0,
				lazyLoad: "ondemand",
				mobileFirst: !1,
				pauseOnHover: !0,
				pauseOnFocus: !0,
				pauseOnDotsHover: !1,
				respondTo: "window",
				responsive: null,
				rows: 1,
				rtl: !1,
				slide: "",
				slidesPerRow: 1,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 500,
				swipe: !0,
				swipeToSlide: !1,
				touchMove: !0,
				touchThreshold: 5,
				useCSS: !0,
				useTransform: !0,
				variableWidth: !1,
				vertical: !1,
				verticalSwiping: !1,
				waitForAnimate: !0,
				zIndex: 1e3
			}, n.initials = {
				animating: !1,
				dragging: !1,
				autoPlayTimer: null,
				currentDirection: 0,
				currentLeft: null,
				currentSlide: 0,
				direction: 1,
				$dots: null,
				listWidth: null,
				listHeight: null,
				loadIndex: 0,
				$nextArrow: null,
				$prevArrow: null,
				scrolling: !1,
				slideCount: null,
				slideWidth: null,
				$slideTrack: null,
				$slides: null,
				sliding: !1,
				slideOffset: 0,
				swipeLeft: null,
				swiping: !1,
				$list: null,
				touchObject: {},
				transformsEnabled: !1,
				unslicked: !1
			}, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(t), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(t).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, void 0 !== document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = e++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0)
		}
	}()).prototype.activateADA = function () {
		this.$slideTrack.find(".slick-active").attr({
			"aria-hidden": "false"
		}).find("a, input, button, select").attr({
			tabindex: "0"
		})
	}, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
		var s = this;
		if ("boolean" == typeof t) o = t, t = null;
		else if (t < 0 || t >= s.slideCount) return !1;
		s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
			i(t).attr("data-slick-index", e)
		}), s.$slidesCache = s.$slides, s.reinit()
	}, e.prototype.animateHeight = function () {
		var i = this;
		if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
			var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
			i.$list.animate({
				height: e
			}, i.options.speed)
		}
	}, e.prototype.animateSlide = function (e, t) {
		var o = {},
			s = this;
		s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (e = -e), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({
			left: e
		}, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
			top: e
		}, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), i({
			animStart: s.currentLeft
		}).animate({
			animStart: e
		}, {
			duration: s.options.speed,
			easing: s.options.easing,
			step: function (i) {
				i = Math.ceil(i), !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o))
			},
			complete: function () {
				t && t.call()
			}
		})) : (s.applyTransition(), e = Math.ceil(e), !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function () {
			s.disableTransition(), t.call()
		}, s.options.speed))
	}, e.prototype.getNavTarget = function () {
		var e = this,
			t = e.options.asNavFor;
		return t && null !== t && (t = i(t).not(e.$slider)), t
	}, e.prototype.asNavFor = function (e) {
		var t = this.getNavTarget();
		null !== t && "object" == typeof t && t.each(function () {
			var t = i(this).slick("getSlick");
			t.unslicked || t.slideHandler(e, !0)
		})
	}, e.prototype.applyTransition = function (i) {
		var e = this,
			t = {};
		!1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
	}, e.prototype.autoPlay = function () {
		var i = this;
		i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
	}, e.prototype.autoPlayClear = function () {
		var i = this;
		i.autoPlayTimer && clearInterval(i.autoPlayTimer)
	}, e.prototype.autoPlayIterator = function () {
		var i = this,
			e = i.currentSlide + i.options.slidesToScroll;
		i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 == 0 && (i.direction = 1))), i.slideHandler(e))
	}, e.prototype.buildArrows = function () {
		var e = this;
		!0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
			"aria-disabled": "true",
			tabindex: "-1"
		}))
	}, e.prototype.buildDots = function () {
		var e, t, o = this;
		if (!0 === o.options.dots) {
			for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
			o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active")
		}
	}, e.prototype.buildOut = function () {
		var e = this;
		e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
			i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "")
		}), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable")
	}, e.prototype.buildRows = function () {
		var i, e, t, o, s, n, r, l = this;
		if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 1) {
			for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
				var d = document.createElement("div");
				for (e = 0; e < l.options.rows; e++) {
					var a = document.createElement("div");
					for (t = 0; t < l.options.slidesPerRow; t++) {
						var c = i * r + (e * l.options.slidesPerRow + t);
						n.get(c) && a.appendChild(n.get(c))
					}
					d.appendChild(a)
				}
				o.appendChild(d)
			}
			l.$slider.empty().append(o), l.$slider.children().children().children().css({
				width: 100 / l.options.slidesPerRow + "%",
				display: "inline-block"
			})
		}
	}, e.prototype.checkResponsive = function (e, t) {
		var o, s, n, r = this,
			l = !1,
			d = r.$slider.width(),
			a = window.innerWidth || i(window).width();
		if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
			s = null;
			for (o in r.breakpoints) r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
			null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || !1 === l || r.$slider.trigger("breakpoint", [r, l])
		}
	}, e.prototype.changeSlide = function (e, t) {
		var o, s, n, r = this,
			l = i(e.currentTarget);
		switch (l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), n = r.slideCount % r.options.slidesToScroll != 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
			case "previous":
				s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
				break;
			case "next":
				s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
				break;
			case "index":
				var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
				r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus");
				break;
			default:
				return
		}
	}, e.prototype.checkNavigable = function (i) {
		var e, t;
		if (e = this.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1];
		else
			for (var o in e) {
				if (i < e[o]) {
					i = t;
					break
				}
				t = e[o]
			}
		return i
	}, e.prototype.cleanUpEvents = function () {
		var e = this;
		e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition)
	}, e.prototype.cleanUpSlideEvents = function () {
		var e = this;
		e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1))
	}, e.prototype.cleanUpRows = function () {
		var i, e = this;
		e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i))
	}, e.prototype.clickHandler = function (i) {
		!1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault())
	}, e.prototype.destroy = function (e) {
		var t = this;
		t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
			i(this).attr("style", i(this).data("originalStyling"))
		}), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t])
	}, e.prototype.disableTransition = function (i) {
		var e = this,
			t = {};
		t[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
	}, e.prototype.fadeSlide = function (i, e) {
		var t = this;
		!1 === t.cssTransitions ? (t.$slides.eq(i).css({
			zIndex: t.options.zIndex
		}), t.$slides.eq(i).animate({
			opacity: 1
		}, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
			opacity: 1,
			zIndex: t.options.zIndex
		}), e && setTimeout(function () {
			t.disableTransition(i), e.call()
		}, t.options.speed))
	}, e.prototype.fadeSlideOut = function (i) {
		var e = this;
		!1 === e.cssTransitions ? e.$slides.eq(i).animate({
			opacity: 0,
			zIndex: e.options.zIndex - 2
		}, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
			opacity: 0,
			zIndex: e.options.zIndex - 2
		}))
	}, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
		var e = this;
		null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit())
	}, e.prototype.focusHandler = function () {
		var e = this;
		e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) {
			t.stopImmediatePropagation();
			var o = i(this);
			setTimeout(function () {
				e.options.pauseOnFocus && (e.focussed = o.is(":focus"), e.autoPlay())
			}, 0)
		})
	}, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
		return this.currentSlide
	}, e.prototype.getDotCount = function () {
		var i = this,
			e = 0,
			t = 0,
			o = 0;
		if (!0 === i.options.infinite)
			if (i.slideCount <= i.options.slidesToShow) ++o;
			else
				for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
		else if (!0 === i.options.centerMode) o = i.slideCount;
		else if (i.options.asNavFor)
			for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
		else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
		return o - 1
	}, e.prototype.getLeft = function (i) {
		var e, t, o, s, n = this,
			r = 0;
		return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), !0 === n.options.infinite ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll != 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : !0 === n.options.centerMode && !0 === n.options.infinite ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : !0 === n.options.centerMode && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, !0 === n.options.variableWidth && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, !0 === n.options.centerMode && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e
	}, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
		return this.options[i]
	}, e.prototype.getNavigableIndexes = function () {
		var i, e = this,
			t = 0,
			o = 0,
			s = [];
		for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll, o = -1 * e.options.slidesToScroll, i = 2 * e.slideCount); t < i;) s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
		return s
	}, e.prototype.getSlick = function () {
		return this
	}, e.prototype.getSlideCount = function () {
		var e, t, o = this;
		return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
			if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return e = n, !1
		}), Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
	}, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
		this.changeSlide({
			data: {
				message: "index",
				index: parseInt(i)
			}
		}, e)
	}, e.prototype.init = function (e) {
		var t = this;
		i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay())
	}, e.prototype.initADA = function () {
		var e = this,
			t = Math.ceil(e.slideCount / e.options.slidesToShow),
			o = e.getNavigableIndexes().filter(function (i) {
				return i >= 0 && i < e.slideCount
			});
		e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
			"aria-hidden": "true",
			tabindex: "-1"
		}).find("a, input, button, select").attr({
			tabindex: "-1"
		}), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
			var s = o.indexOf(t);
			i(this).attr({
				role: "tabpanel",
				id: "slick-slide" + e.instanceUid + t,
				tabindex: -1
			}), -1 !== s && i(this).attr({
				"aria-describedby": "slick-slide-control" + e.instanceUid + s
			})
		}), e.$dots.attr("role", "tablist").find("li").each(function (s) {
			var n = o[s];
			i(this).attr({
				role: "presentation"
			}), i(this).find("button").first().attr({
				role: "tab",
				id: "slick-slide-control" + e.instanceUid + s,
				"aria-controls": "slick-slide" + e.instanceUid + n,
				"aria-label": s + 1 + " of " + t,
				"aria-selected": null,
				tabindex: "-1"
			})
		}).eq(e.currentSlide).find("button").attr({
			"aria-selected": "true",
			tabindex: "0"
		}).end());
		for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) e.$slides.eq(s).attr("tabindex", 0);
		e.activateADA()
	}, e.prototype.initArrowEvents = function () {
		var i = this;
		!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {
			message: "previous"
		}, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", {
			message: "next"
		}, i.changeSlide), !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)))
	}, e.prototype.initDotEvents = function () {
		var e = this;
		!0 === e.options.dots && (i("li", e.$dots).on("click.slick", {
			message: "index"
		}, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1))
	}, e.prototype.initSlideEvents = function () {
		var e = this;
		e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)))
	}, e.prototype.initializeEvents = function () {
		var e = this;
		e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
			action: "start"
		}, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
			action: "move"
		}, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
			action: "end"
		}, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
			action: "end"
		}, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(e.setPosition)
	}, e.prototype.initUI = function () {
		var i = this;
		!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show()
	}, e.prototype.keyHandler = function (i) {
		var e = this;
		i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({
			data: {
				message: !0 === e.options.rtl ? "next" : "previous"
			}
		}) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({
			data: {
				message: !0 === e.options.rtl ? "previous" : "next"
			}
		}))
	}, e.prototype.lazyLoad = function () {
		function e(e) {
			i("img[data-lazy]", e).each(function () {
				var e = i(this),
					t = i(this).attr("data-lazy"),
					o = i(this).attr("data-srcset"),
					s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
					r = document.createElement("img");
				r.onload = function () {
					e.animate({
						opacity: 0
					}, 100, function () {
						o && (e.attr("srcset", o), s && e.attr("sizes", s)), e.attr("src", t).animate({
							opacity: 1
						}, 200, function () {
							e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
						}), n.$slider.trigger("lazyLoaded", [n, e, t])
					})
				}, r.onerror = function () {
					e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, e, t])
				}, r.src = t
			})
		}
		var t, o, s, n = this;
		if (!0 === n.options.centerMode ? !0 === n.options.infinite ? s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)), s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide, s = Math.ceil(o + n.options.slidesToShow), !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)), t = n.$slider.find(".slick-slide").slice(o, s), "anticipated" === n.options.lazyLoad)
			for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++) r < 0 && (r = n.slideCount - 1), t = (t = t.add(d.eq(r))).add(d.eq(l)), r--, l++;
		e(t), n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow))
	}, e.prototype.loadSlider = function () {
		var i = this;
		i.setPosition(), i.$slideTrack.css({
			opacity: 1
		}), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad()
	}, e.prototype.next = e.prototype.slickNext = function () {
		this.changeSlide({
			data: {
				message: "next"
			}
		})
	}, e.prototype.orientationChange = function () {
		var i = this;
		i.checkResponsive(), i.setPosition()
	}, e.prototype.pause = e.prototype.slickPause = function () {
		var i = this;
		i.autoPlayClear(), i.paused = !0
	}, e.prototype.play = e.prototype.slickPlay = function () {
		var i = this;
		i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1
	}, e.prototype.postSlide = function (e) {
		var t = this;
		t.unslicked || (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()))
	}, e.prototype.prev = e.prototype.slickPrev = function () {
		this.changeSlide({
			data: {
				message: "previous"
			}
		})
	}, e.prototype.preventDefault = function (i) {
		i.preventDefault()
	}, e.prototype.progressiveLazyLoad = function (e) {
		e = e || 1;
		var t, o, s, n, r, l = this,
			d = i("img[data-lazy]", l.$slider);
		d.length ? (t = d.first(), o = t.attr("data-lazy"), s = t.attr("data-srcset"), n = t.attr("data-sizes") || l.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function () {
			s && (t.attr("srcset", s), n && t.attr("sizes", n)), t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === l.options.adaptiveHeight && l.setPosition(), l.$slider.trigger("lazyLoaded", [l, t, o]), l.progressiveLazyLoad()
		}, r.onerror = function () {
			e < 3 ? setTimeout(function () {
				l.progressiveLazyLoad(e + 1)
			}, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), l.$slider.trigger("lazyLoadError", [l, t, o]), l.progressiveLazyLoad())
		}, r.src = o) : l.$slider.trigger("allImagesLoaded", [l])
	}, e.prototype.refresh = function (e) {
		var t, o, s = this;
		o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {
			currentSlide: t
		}), s.init(), e || s.changeSlide({
			data: {
				message: "index",
				index: t
			}
		}, !1)
	}, e.prototype.registerBreakpoints = function () {
		var e, t, o, s = this,
			n = s.options.responsive || null;
		if ("array" === i.type(n) && n.length) {
			s.respondTo = s.options.respondTo || "window";
			for (e in n)
				if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
					for (t = n[e].breakpoint; o >= 0;) s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
					s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings
				}
			s.breakpoints.sort(function (i, e) {
				return s.options.mobileFirst ? i - e : e - i
			})
		}
	}, e.prototype.reinit = function () {
		var e = this;
		e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
	}, e.prototype.resize = function () {
		var e = this;
		i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
			e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
		}, 50))
	}, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
		var o = this;
		if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i, o.slideCount < 1 || i < 0 || i > o.slideCount - 1) return !1;
		o.unload(), !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, o.reinit()
	}, e.prototype.setCSS = function (i) {
		var e, t, o = this,
			s = {};
		!0 === o.options.rtl && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {}, !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s)))
	}, e.prototype.setDimensions = function () {
		var i = this;
		!1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({
			padding: "0px " + i.options.centerPadding
		}) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({
			padding: i.options.centerPadding + " 0px"
		})), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
		var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
		!1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e)
	}, e.prototype.setFade = function () {
		var e, t = this;
		t.$slides.each(function (o, s) {
			e = t.slideWidth * o * -1, !0 === t.options.rtl ? i(s).css({
				position: "relative",
				right: e,
				top: 0,
				zIndex: t.options.zIndex - 2,
				opacity: 0
			}) : i(s).css({
				position: "relative",
				left: e,
				top: 0,
				zIndex: t.options.zIndex - 2,
				opacity: 0
			})
		}), t.$slides.eq(t.currentSlide).css({
			zIndex: t.options.zIndex - 1,
			opacity: 1
		})
	}, e.prototype.setHeight = function () {
		var i = this;
		if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
			var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
			i.$list.css("height", e)
		}
	}, e.prototype.setOption = e.prototype.slickSetOption = function () {
		var e, t, o, s, n, r = this,
			l = !1;
		if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) r.options[o] = s;
		else if ("multiple" === n) i.each(o, function (i, e) {
			r.options[i] = e
		});
		else if ("responsive" === n)
			for (t in s)
				if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]];
				else {
					for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
					r.options.responsive.push(s[t])
				}
		l && (r.unload(), r.reinit())
	}, e.prototype.setPosition = function () {
		var i = this;
		i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i])
	}, e.prototype.setProps = function () {
		var i = this,
			e = document.body.style;
		i.positionProp = !0 === i.options.vertical ? "top" : "left", "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType
	}, e.prototype.setSlideClasses = function (i) {
		var e, t, o, s, n = this;
		if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), !0 === n.options.centerMode) {
			var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
			e = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center")
		} else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = !0 === n.options.infinite ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
		"ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad()
	}, e.prototype.setupInfinite = function () {
		var e, t, o, s = this;
		if (!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (t = null, s.slideCount > s.options.slidesToShow)) {
			for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
			for (e = 0; e < o + s.slideCount; e += 1) t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
			s.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
				i(this).attr("id", "")
			})
		}
	}, e.prototype.interrupt = function (i) {
		var e = this;
		i || e.autoPlay(), e.interrupted = i
	}, e.prototype.selectHandler = function (e) {
		var t = this,
			o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
			s = parseInt(o.attr("data-slick-index"));
		s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s)
	}, e.prototype.slideHandler = function (i, e, t) {
		var o, s, n, r, l, d = null,
			a = this;
		if (e = e || !1, !(!0 === a.animating && !0 === a.options.waitForAnimate || !0 === a.options.fade && a.currentSlide === i))
			if (!1 === e && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
				a.postSlide(o)
			}) : a.postSlide(o));
			else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
			a.postSlide(o)
		}) : a.postSlide(o));
		else {
			if (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide), a.updateDots(), a.updateArrows(), !0 === a.options.fade) return !0 !== t ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
				a.postSlide(s)
			})) : a.postSlide(s), void a.animateHeight();
			!0 !== t ? a.animateSlide(d, function () {
				a.postSlide(s)
			}) : a.postSlide(s)
		}
	}, e.prototype.startLoad = function () {
		var i = this;
		!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading")
	}, e.prototype.swipeDirection = function () {
		var i, e, t, o, s = this;
		return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical"
	}, e.prototype.swipeEnd = function (i) {
		var e, t, o = this;
		if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
		if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;
		if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
			switch (t = o.swipeDirection()) {
				case "left":
				case "down":
					e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
					break;
				case "right":
				case "up":
					e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1
			}
			"vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t]))
		} else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {})
	}, e.prototype.swipeHandler = function (i) {
		var e = this;
		if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
			case "start":
				e.swipeStart(i);
				break;
			case "move":
				e.swipeMove(i);
				break;
			case "end":
				e.swipeEnd(i)
		}
	}, e.prototype.swipeMove = function (i) {
		var e, t, o, s, n, r, l = this;
		return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s), !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))))
	}, e.prototype.swipeStart = function (i) {
		var e, t = this;
		if (t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow) return t.touchObject = {}, !1;
		void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, t.dragging = !0
	}, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
		var i = this;
		null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit())
	}, e.prototype.unload = function () {
		var e = this;
		i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
	}, e.prototype.unslick = function (i) {
		var e = this;
		e.$slider.trigger("unslick", [e, i]), e.destroy()
	}, e.prototype.updateArrows = function () {
		var i = this;
		Math.floor(i.options.slidesToShow / 2), !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
	}, e.prototype.updateDots = function () {
		var i = this;
		null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"))
	}, e.prototype.visibility = function () {
		var i = this;
		i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1)
	}, i.fn.slick = function () {
		var i, t, o = this,
			s = arguments[0],
			n = Array.prototype.slice.call(arguments, 1),
			r = o.length;
		for (i = 0; i < r; i++)
			if ("object" == typeof s || void 0 === s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), void 0 !== t) return t;
		return o
	}
});
(function (window, document, $, undefined) {
	"use strict";
	var H = $("html"),
		W = $(window),
		D = $(document),
		F = $.fancybox = function () {
			F.open.apply(this, arguments)
		},
		IE = navigator.userAgent.match(/msie/i),
		didUpdate = null,
		isTouch = document.createTouch !== undefined,
		isQuery = function (obj) {
			return obj && obj.hasOwnProperty && obj instanceof $
		},
		isString = function (str) {
			return str && $.type(str) === "string"
		},
		isPercentage = function (str) {
			return isString(str) && str.indexOf("%") > 0
		},
		isScrollable = function (el) {
			return el && !(el.style.overflow && el.style.overflow === "hidden") && (el.clientWidth && el.scrollWidth > el.clientWidth || el.clientHeight && el.scrollHeight > el.clientHeight)
		},
		getScalar = function (orig, dim) {
			var value = parseInt(orig, 10) || 0;
			if (dim && isPercentage(orig)) {
				value = F.getViewport()[dim] / 100 * value
			}
			return Math.ceil(value)
		},
		getValue = function (value, dim) {
			return getScalar(value, dim) + "px"
		};
	$.extend(F, {
		version: "2.1.7",
		defaults: {
			padding: 15,
			margin: 20,
			width: 800,
			height: 600,
			minWidth: 100,
			minHeight: 100,
			maxWidth: 9999,
			maxHeight: 9999,
			pixelRatio: 1,
			autoSize: true,
			autoHeight: false,
			autoWidth: false,
			autoResize: true,
			autoCenter: !isTouch,
			fitToView: true,
			aspectRatio: false,
			topRatio: .5,
			leftRatio: .5,
			scrolling: "auto",
			wrapCSS: "",
			arrows: true,
			closeBtn: true,
			closeClick: false,
			nextClick: false,
			mouseWheel: true,
			autoPlay: false,
			playSpeed: 3e3,
			preload: 3,
			modal: false,
			loop: true,
			ajax: {
				dataType: "html",
				headers: {
					"X-fancyBox": true
				}
			},
			iframe: {
				scrolling: "auto",
				preload: true
			},
			swf: {
				wmode: "transparent",
				allowfullscreen: "true",
				allowscriptaccess: "always"
			},
			keys: {
				next: {
					13: "left",
					34: "up",
					39: "left",
					40: "up"
				},
				prev: {
					8: "right",
					33: "down",
					37: "right",
					38: "down"
				},
				close: [27],
				play: [32],
				toggle: [70]
			},
			direction: {
				next: "left",
				prev: "right"
			},
			scrollOutside: true,
			index: 0,
			type: null,
			href: null,
			content: null,
			title: null,
			tpl: {
				wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
				image: '<img class="fancybox-image" src="{href}" alt="" />',
				iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (IE ? ' allowtransparency="true"' : "") + "></iframe>",
				error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
				closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
				next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
				prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
				loading: '<div id="fancybox-loading"><div></div></div>'
			},
			openEffect: "fade",
			openSpeed: 250,
			openEasing: "swing",
			openOpacity: true,
			openMethod: "zoomIn",
			closeEffect: "fade",
			closeSpeed: 250,
			closeEasing: "swing",
			closeOpacity: true,
			closeMethod: "zoomOut",
			nextEffect: "elastic",
			nextSpeed: 250,
			nextEasing: "swing",
			nextMethod: "changeIn",
			prevEffect: "elastic",
			prevSpeed: 250,
			prevEasing: "swing",
			prevMethod: "changeOut",
			helpers: {
				overlay: true,
				title: true
			},
			onCancel: $.noop,
			beforeLoad: $.noop,
			afterLoad: $.noop,
			beforeShow: $.noop,
			afterShow: $.noop,
			beforeChange: $.noop,
			beforeClose: $.noop,
			afterClose: $.noop
		},
		group: {},
		opts: {},
		previous: null,
		coming: null,
		current: null,
		isActive: false,
		isOpen: false,
		isOpened: false,
		wrap: null,
		skin: null,
		outer: null,
		inner: null,
		player: {
			timer: null,
			isActive: false
		},
		ajaxLoad: null,
		imgPreload: null,
		transitions: {},
		helpers: {},
		open: function (group, opts) {
			if (!group) {
				return
			}
			if (!$.isPlainObject(opts)) {
				opts = {}
			}
			if (false === F.close(true)) {
				return
			}
			if (!$.isArray(group)) {
				group = isQuery(group) ? $(group).get() : [group]
			}
			$.each(group, function (i, element) {
				var obj = {},
					href, title, content, type, rez, hrefParts, selector;
				if ($.type(element) === "object") {
					if (element.nodeType) {
						element = $(element)
					}
					if (isQuery(element)) {
						obj = {
							href: element.data("fancybox-href") || element.attr("href"),
							title: $("<div/>").text(element.data("fancybox-title") || element.attr("title") || "").html(),
							isDom: true,
							element: element
						};
						if ($.metadata) {
							$.extend(true, obj, element.metadata())
						}
					} else {
						obj = element
					}
				}
				href = opts.href || obj.href || (isString(element) ? element : null);
				title = opts.title !== undefined ? opts.title : obj.title || "";
				content = opts.content || obj.content;
				type = content ? "html" : opts.type || obj.type;
				if (!type && obj.isDom) {
					type = element.data("fancybox-type");
					if (!type) {
						rez = element.prop("class").match(/fancybox\.(\w+)/);
						type = rez ? rez[1] : null
					}
				}
				if (isString(href)) {
					if (!type) {
						if (F.isImage(href)) {
							type = "image"
						} else if (F.isSWF(href)) {
							type = "swf"
						} else if (href.charAt(0) === "#") {
							type = "inline"
						} else if (isString(element)) {
							type = "html";
							content = element
						}
					}
					if (type === "ajax") {
						hrefParts = href.split(/\s+/, 2);
						href = hrefParts.shift();
						selector = hrefParts.shift()
					}
				}
				if (!content) {
					if (type === "inline") {
						if (href) {
							content = $(isString(href) ? href.replace(/.*(?=#[^\s]+$)/, "") : href)
						} else if (obj.isDom) {
							content = element
						}
					} else if (type === "html") {
						content = href
					} else if (!type && !href && obj.isDom) {
						type = "inline";
						content = element
					}
				}
				$.extend(obj, {
					href: href,
					type: type,
					content: content,
					title: title,
					selector: selector
				});
				group[i] = obj
			});
			F.opts = $.extend(true, {}, F.defaults, opts);
			if (opts.keys !== undefined) {
				F.opts.keys = opts.keys ? $.extend({}, F.defaults.keys, opts.keys) : false
			}
			F.group = group;
			return F._start(F.opts.index)
		},
		cancel: function () {
			var coming = F.coming;
			if (coming && false === F.trigger("onCancel")) {
				return
			}
			F.hideLoading();
			if (!coming) {
				return
			}
			if (F.ajaxLoad) {
				F.ajaxLoad.abort()
			}
			F.ajaxLoad = null;
			if (F.imgPreload) {
				F.imgPreload.onload = F.imgPreload.onerror = null
			}
			if (coming.wrap) {
				coming.wrap.stop(true, true).trigger("onReset").remove()
			}
			F.coming = null;
			if (!F.current) {
				F._afterZoomOut(coming)
			}
		},
		close: function (event) {
			F.cancel();
			if (false === F.trigger("beforeClose")) {
				return
			}
			F.unbindEvents();
			if (!F.isActive) {
				return
			}
			if (!F.isOpen || event === true) {
				$(".fancybox-wrap").stop(true).trigger("onReset").remove();
				F._afterZoomOut()
			} else {
				F.isOpen = F.isOpened = false;
				F.isClosing = true;
				$(".fancybox-item, .fancybox-nav").remove();
				F.wrap.stop(true, true).removeClass("fancybox-opened");
				F.transitions[F.current.closeMethod]()
			}
		},
		play: function (action) {
			var clear = function () {
					clearTimeout(F.player.timer)
				},
				set = function () {
					clear();
					if (F.current && F.player.isActive) {
						F.player.timer = setTimeout(F.next, F.current.playSpeed)
					}
				},
				stop = function () {
					clear();
					D.unbind(".player");
					F.player.isActive = false;
					F.trigger("onPlayEnd")
				},
				start = function () {
					if (F.current && (F.current.loop || F.current.index < F.group.length - 1)) {
						F.player.isActive = true;
						D.bind({
							"onCancel.player beforeClose.player": stop,
							"onUpdate.player": set,
							"beforeLoad.player": clear
						});
						set();
						F.trigger("onPlayStart")
					}
				};
			if (action === true || !F.player.isActive && action !== false) {
				start()
			} else {
				stop()
			}
		},
		next: function (direction) {
			var current = F.current;
			if (current) {
				if (!isString(direction)) {
					direction = current.direction.next
				}
				F.jumpto(current.index + 1, direction, "next")
			}
		},
		prev: function (direction) {
			var current = F.current;
			if (current) {
				if (!isString(direction)) {
					direction = current.direction.prev
				}
				F.jumpto(current.index - 1, direction, "prev")
			}
		},
		jumpto: function (index, direction, router) {
			var current = F.current;
			if (!current) {
				return
			}
			index = getScalar(index);
			F.direction = direction || current.direction[index >= current.index ? "next" : "prev"];
			F.router = router || "jumpto";
			if (current.loop) {
				if (index < 0) {
					index = current.group.length + index % current.group.length
				}
				index = index % current.group.length
			}
			if (current.group[index] !== undefined) {
				F.cancel();
				F._start(index)
			}
		},
		reposition: function (e, onlyAbsolute) {
			var current = F.current,
				wrap = current ? current.wrap : null,
				pos;
			if (wrap) {
				pos = F._getPosition(onlyAbsolute);
				if (e && e.type === "scroll") {
					delete pos.position;
					wrap.stop(true, true).animate(pos, 200)
				} else {
					wrap.css(pos);
					current.pos = $.extend({}, current.dim, pos)
				}
			}
		},
		update: function (e) {
			var type = e && e.originalEvent && e.originalEvent.type,
				anyway = !type || type === "orientationchange";
			if (anyway) {
				clearTimeout(didUpdate);
				didUpdate = null
			}
			if (!F.isOpen || didUpdate) {
				return
			}
			didUpdate = setTimeout(function () {
				var current = F.current;
				if (!current || F.isClosing) {
					return
				}
				F.wrap.removeClass("fancybox-tmp");
				if (anyway || type === "load" || type === "resize" && current.autoResize) {
					F._setDimension()
				}
				if (!(type === "scroll" && current.canShrink)) {
					F.reposition(e)
				}
				F.trigger("onUpdate");
				didUpdate = null
			}, anyway && !isTouch ? 0 : 300)
		},
		toggle: function (action) {
			if (F.isOpen) {
				F.current.fitToView = $.type(action) === "boolean" ? action : !F.current.fitToView;
				if (isTouch) {
					F.wrap.removeAttr("style").addClass("fancybox-tmp");
					F.trigger("onUpdate")
				}
				F.update()
			}
		},
		hideLoading: function () {
			D.unbind(".loading");
			$("#fancybox-loading").remove()
		},
		showLoading: function () {
			var el, viewport;
			F.hideLoading();
			el = $(F.opts.tpl.loading).click(F.cancel).appendTo("body");
			D.bind("keydown.loading", function (e) {
				if ((e.which || e.keyCode) === 27) {
					e.preventDefault();
					F.cancel()
				}
			});
			if (!F.defaults.fixed) {
				viewport = F.getViewport();
				el.css({
					position: "absolute",
					top: viewport.h * .5 + viewport.y,
					left: viewport.w * .5 + viewport.x
				})
			}
			F.trigger("onLoading")
		},
		getViewport: function () {
			var locked = F.current && F.current.locked || false,
				rez = {
					x: W.scrollLeft(),
					y: W.scrollTop()
				};
			if (locked && locked.length) {
				rez.w = locked[0].clientWidth;
				rez.h = locked[0].clientHeight
			} else {
				rez.w = isTouch && window.innerWidth ? window.innerWidth : W.width();
				rez.h = isTouch && window.innerHeight ? window.innerHeight : W.height()
			}
			return rez
		},
		unbindEvents: function () {
			if (F.wrap && isQuery(F.wrap)) {
				F.wrap.unbind(".fb")
			}
			D.unbind(".fb");
			W.unbind(".fb")
		},
		bindEvents: function () {
			var current = F.current,
				keys;
			if (!current) {
				return
			}
			W.bind("orientationchange.fb" + (isTouch ? "" : " resize.fb") + (current.autoCenter && !current.locked ? " scroll.fb" : ""), F.update);
			keys = current.keys;
			if (keys) {
				D.bind("keydown.fb", function (e) {
					var code = e.which || e.keyCode,
						target = e.target || e.srcElement;
					if (code === 27 && F.coming) {
						return false
					}
					if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey && !(target && (target.type || $(target).is("[contenteditable]")))) {
						$.each(keys, function (i, val) {
							if (current.group.length > 1 && val[code] !== undefined) {
								F[i](val[code]);
								e.preventDefault();
								return false
							}
							if ($.inArray(code, val) > -1) {
								F[i]();
								e.preventDefault();
								return false
							}
						})
					}
				})
			}
			if ($.fn.mousewheel && current.mouseWheel) {
				F.wrap.bind("mousewheel.fb", function (e, delta, deltaX, deltaY) {
					var target = e.target || null,
						parent = $(target),
						canScroll = false;
					while (parent.length) {
						if (canScroll || parent.is(".fancybox-skin") || parent.is(".fancybox-wrap")) {
							break
						}
						canScroll = isScrollable(parent[0]);
						parent = $(parent).parent()
					}
					if (delta !== 0 && !canScroll) {
						if (F.group.length > 1 && !current.canShrink) {
							if (deltaY > 0 || deltaX > 0) {
								F.prev(deltaY > 0 ? "down" : "left")
							} else if (deltaY < 0 || deltaX < 0) {
								F.next(deltaY < 0 ? "up" : "right")
							}
							e.preventDefault()
						}
					}
				})
			}
		},
		trigger: function (event, o) {
			var ret, obj = o || F.coming || F.current;
			if (obj) {
				if ($.isFunction(obj[event])) {
					ret = obj[event].apply(obj, Array.prototype.slice.call(arguments, 1))
				}
				if (ret === false) {
					return false
				}
				if (obj.helpers) {
					$.each(obj.helpers, function (helper, opts) {
						if (opts && F.helpers[helper] && $.isFunction(F.helpers[helper][event])) {
							F.helpers[helper][event]($.extend(true, {}, F.helpers[helper].defaults, opts), obj)
						}
					})
				}
			}
			D.trigger(event)
		},
		isImage: function (str) {
			return isString(str) && str.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)
		},
		isSWF: function (str) {
			return isString(str) && str.match(/\.(swf)((\?|#).*)?$/i)
		},
		_start: function (index) {
			var coming = {},
				obj, href, type, margin, padding;
			index = getScalar(index);
			obj = F.group[index] || null;
			if (!obj) {
				return false
			}
			coming = $.extend(true, {}, F.opts, obj);
			margin = coming.margin;
			padding = coming.padding;
			if ($.type(margin) === "number") {
				coming.margin = [margin, margin, margin, margin]
			}
			if ($.type(padding) === "number") {
				coming.padding = [padding, padding, padding, padding]
			}
			if (coming.modal) {
				$.extend(true, coming, {
					closeBtn: false,
					closeClick: false,
					nextClick: false,
					arrows: false,
					mouseWheel: false,
					keys: null,
					helpers: {
						overlay: {
							closeClick: false
						}
					}
				})
			}
			if (coming.autoSize) {
				coming.autoWidth = coming.autoHeight = true
			}
			if (coming.width === "auto") {
				coming.autoWidth = true
			}
			if (coming.height === "auto") {
				coming.autoHeight = true
			}
			coming.group = F.group;
			coming.index = index;
			F.coming = coming;
			if (false === F.trigger("beforeLoad")) {
				F.coming = null;
				return
			}
			type = coming.type;
			href = coming.href;
			if (!type) {
				F.coming = null;
				if (F.current && F.router && F.router !== "jumpto") {
					F.current.index = index;
					return F[F.router](F.direction)
				}
				return false
			}
			F.isActive = true;
			if (type === "image" || type === "swf") {
				coming.autoHeight = coming.autoWidth = false;
				coming.scrolling = "visible"
			}
			if (type === "image") {
				coming.aspectRatio = true
			}
			if (type === "iframe" && isTouch) {
				coming.scrolling = "scroll"
			}
			coming.wrap = $(coming.tpl.wrap).addClass("fancybox-" + (isTouch ? "mobile" : "desktop") + " fancybox-type-" + type + " fancybox-tmp " + coming.wrapCSS).appendTo(coming.parent || "body");
			$.extend(coming, {
				skin: $(".fancybox-skin", coming.wrap),
				outer: $(".fancybox-outer", coming.wrap),
				inner: $(".fancybox-inner", coming.wrap)
			});
			$.each(["Top", "Right", "Bottom", "Left"], function (i, v) {
				coming.skin.css("padding" + v, getValue(coming.padding[i]))
			});
			F.trigger("onReady");
			if (type === "inline" || type === "html") {
				if (!coming.content || !coming.content.length) {
					return F._error("content")
				}
			} else if (!href) {
				return F._error("href")
			}
			if (type === "image") {
				F._loadImage()
			} else if (type === "ajax") {
				F._loadAjax()
			} else if (type === "iframe") {
				F._loadIframe()
			} else {
				F._afterLoad()
			}
		},
		_error: function (type) {
			$.extend(F.coming, {
				type: "html",
				autoWidth: true,
				autoHeight: true,
				minWidth: 0,
				minHeight: 0,
				scrolling: "no",
				hasError: type,
				content: F.coming.tpl.error
			});
			F._afterLoad()
		},
		_loadImage: function () {
			var img = F.imgPreload = new Image;
			img.onload = function () {
				this.onload = this.onerror = null;
				F.coming.width = this.width / F.opts.pixelRatio;
				F.coming.height = this.height / F.opts.pixelRatio;
				F._afterLoad()
			};
			img.onerror = function () {
				this.onload = this.onerror = null;
				F._error("image")
			};
			img.src = F.coming.href;
			if (img.complete !== true) {
				F.showLoading()
			}
		},
		_loadAjax: function () {
			var coming = F.coming;
			F.showLoading();
			F.ajaxLoad = $.ajax($.extend({}, coming.ajax, {
				url: coming.href,
				error: function (jqXHR, textStatus) {
					if (F.coming && textStatus !== "abort") {
						F._error("ajax", jqXHR)
					} else {
						F.hideLoading()
					}
				},
				success: function (data, textStatus) {
					if (textStatus === "success") {
						coming.content = data;
						F._afterLoad()
					}
				}
			}))
		},
		_loadIframe: function () {
			var coming = F.coming,
				iframe = $(coming.tpl.iframe.replace(/\{rnd\}/g, (new Date).getTime())).attr("scrolling", isTouch ? "auto" : coming.iframe.scrolling).attr("src", coming.href);
			$(coming.wrap).bind("onReset", function () {
				try {
					$(this).find("iframe").hide().attr("src", "//about:blank").end().empty()
				} catch (e) {}
			});
			if (coming.iframe.preload) {
				F.showLoading();
				iframe.one("load", function () {
					$(this).data("ready", 1);
					if (!isTouch) {
						$(this).bind("load.fb", F.update)
					}
					$(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show();
					F._afterLoad()
				})
			}
			coming.content = iframe.appendTo(coming.inner);
			if (!coming.iframe.preload) {
				F._afterLoad()
			}
		},
		_preloadImages: function () {
			var group = F.group,
				current = F.current,
				len = group.length,
				cnt = current.preload ? Math.min(current.preload, len - 1) : 0,
				item, i;
			for (i = 1; i <= cnt; i += 1) {
				item = group[(current.index + i) % len];
				if (item.type === "image" && item.href) {
					(new Image).src = item.href
				}
			}
		},
		_afterLoad: function () {
			var coming = F.coming,
				previous = F.current,
				placeholder = "fancybox-placeholder",
				current, content, type, scrolling, href, embed;
			F.hideLoading();
			if (!coming || F.isActive === false) {
				return
			}
			if (false === F.trigger("afterLoad", coming, previous)) {
				coming.wrap.stop(true).trigger("onReset").remove();
				F.coming = null;
				return
			}
			if (previous) {
				F.trigger("beforeChange", previous);
				previous.wrap.stop(true).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove()
			}
			F.unbindEvents();
			current = coming;
			content = coming.content;
			type = coming.type;
			scrolling = coming.scrolling;
			$.extend(F, {
				wrap: current.wrap,
				skin: current.skin,
				outer: current.outer,
				inner: current.inner,
				current: current,
				previous: previous
			});
			href = current.href;
			switch (type) {
				case "inline":
				case "ajax":
				case "html":
					if (current.selector) {
						content = $("<div>").html(content).find(current.selector)
					} else if (isQuery(content)) {
						if (!content.data(placeholder)) {
							content.data(placeholder, $('<div class="' + placeholder + '"></div>').insertAfter(content).hide())
						}
						content = content.show().detach();
						current.wrap.bind("onReset", function () {
							if ($(this).find(content).length) {
								content.hide().replaceAll(content.data(placeholder)).data(placeholder, false)
							}
						})
					}
					break;
				case "image":
					content = current.tpl.image.replace(/\{href\}/g, href);
					break;
				case "swf":
					content = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + href + '"></param>';
					embed = "";
					$.each(current.swf, function (name, val) {
						content += '<param name="' + name + '" value="' + val + '"></param>';
						embed += " " + name + '="' + val + '"'
					});
					content += '<embed src="' + href + '" type="application/x-shockwave-flash" width="100%" height="100%"' + embed + "></embed></object>";
					break
			}
			if (!(isQuery(content) && content.parent().is(current.inner))) {
				current.inner.append(content)
			}
			F.trigger("beforeShow");
			current.inner.css("overflow", scrolling === "yes" ? "scroll" : scrolling === "no" ? "hidden" : scrolling);
			F._setDimension();
			F.reposition();
			F.isOpen = false;
			F.coming = null;
			F.bindEvents();
			if (!F.isOpened) {
				$(".fancybox-wrap").not(current.wrap).stop(true).trigger("onReset").remove()
			} else if (previous.prevMethod) {
				F.transitions[previous.prevMethod]()
			}
			F.transitions[F.isOpened ? current.nextMethod : current.openMethod]();
			F._preloadImages()
		},
		_setDimension: function () {
			var viewport = F.getViewport(),
				steps = 0,
				canShrink = false,
				canExpand = false,
				wrap = F.wrap,
				skin = F.skin,
				inner = F.inner,
				current = F.current,
				width = current.width,
				height = current.height,
				minWidth = current.minWidth,
				minHeight = current.minHeight,
				maxWidth = current.maxWidth,
				maxHeight = current.maxHeight,
				scrolling = current.scrolling,
				scrollOut = current.scrollOutside ? current.scrollbarWidth : 0,
				margin = current.margin,
				wMargin = getScalar(margin[1] + margin[3]),
				hMargin = getScalar(margin[0] + margin[2]),
				wPadding, hPadding, wSpace, hSpace, origWidth, origHeight, origMaxWidth, origMaxHeight, ratio, width_, height_, maxWidth_, maxHeight_, iframe, body;
			wrap.add(skin).add(inner).width("auto").height("auto").removeClass("fancybox-tmp");
			wPadding = getScalar(skin.outerWidth(true) - skin.width());
			hPadding = getScalar(skin.outerHeight(true) - skin.height());
			wSpace = wMargin + wPadding;
			hSpace = hMargin + hPadding;
			origWidth = isPercentage(width) ? (viewport.w - wSpace) * getScalar(width) / 100 : width;
			origHeight = isPercentage(height) ? (viewport.h - hSpace) * getScalar(height) / 100 : height;
			if (current.type === "iframe") {
				iframe = current.content;
				if (current.autoHeight && iframe && iframe.data("ready") === 1) {
					try {
						if (iframe[0].contentWindow.document.location) {
							inner.width(origWidth).height(9999);
							body = iframe.contents().find("body");
							if (scrollOut) {
								body.css("overflow-x", "hidden")
							}
							origHeight = body.outerHeight(true)
						}
					} catch (e) {}
				}
			} else if (current.autoWidth || current.autoHeight) {
				inner.addClass("fancybox-tmp");
				if (!current.autoWidth) {
					inner.width(origWidth)
				}
				if (!current.autoHeight) {
					inner.height(origHeight)
				}
				if (current.autoWidth) {
					origWidth = inner.width()
				}
				if (current.autoHeight) {
					origHeight = inner.height()
				}
				inner.removeClass("fancybox-tmp")
			}
			width = getScalar(origWidth);
			height = getScalar(origHeight);
			ratio = origWidth / origHeight;
			minWidth = getScalar(isPercentage(minWidth) ? getScalar(minWidth, "w") - wSpace : minWidth);
			maxWidth = getScalar(isPercentage(maxWidth) ? getScalar(maxWidth, "w") - wSpace : maxWidth);
			minHeight = getScalar(isPercentage(minHeight) ? getScalar(minHeight, "h") - hSpace : minHeight);
			maxHeight = getScalar(isPercentage(maxHeight) ? getScalar(maxHeight, "h") - hSpace : maxHeight);
			origMaxWidth = maxWidth;
			origMaxHeight = maxHeight;
			if (current.fitToView) {
				maxWidth = Math.min(viewport.w - wSpace, maxWidth);
				maxHeight = Math.min(viewport.h - hSpace, maxHeight)
			}
			maxWidth_ = viewport.w - wMargin;
			maxHeight_ = viewport.h - hMargin;
			if (current.aspectRatio) {
				if (width > maxWidth) {
					width = maxWidth;
					height = getScalar(width / ratio)
				}
				if (height > maxHeight) {
					height = maxHeight;
					width = getScalar(height * ratio)
				}
				if (width < minWidth) {
					width = minWidth;
					height = getScalar(width / ratio)
				}
				if (height < minHeight) {
					height = minHeight;
					width = getScalar(height * ratio)
				}
			} else {
				width = Math.max(minWidth, Math.min(width, maxWidth));
				if (current.autoHeight && current.type !== "iframe") {
					inner.width(width);
					height = inner.height()
				}
				height = Math.max(minHeight, Math.min(height, maxHeight))
			}
			if (current.fitToView) {
				inner.width(width).height(height);
				wrap.width(width + wPadding);
				width_ = wrap.width();
				height_ = wrap.height();
				if (current.aspectRatio) {
					while ((width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight) {
						if (steps++ > 19) {
							break
						}
						height = Math.max(minHeight, Math.min(maxHeight, height - 10));
						width = getScalar(height * ratio);
						if (width < minWidth) {
							width = minWidth;
							height = getScalar(width / ratio)
						}
						if (width > maxWidth) {
							width = maxWidth;
							height = getScalar(width / ratio)
						}
						inner.width(width).height(height);
						wrap.width(width + wPadding);
						width_ = wrap.width();
						height_ = wrap.height()
					}
				} else {
					width = Math.max(minWidth, Math.min(width, width - (width_ - maxWidth_)));
					height = Math.max(minHeight, Math.min(height, height - (height_ - maxHeight_)))
				}
			}
			if (scrollOut && scrolling === "auto" && height < origHeight && width + wPadding + scrollOut < maxWidth_) {
				width += scrollOut
			}
			inner.width(width).height(height);
			wrap.width(width + wPadding);
			width_ = wrap.width();
			height_ = wrap.height();
			canShrink = (width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight;
			canExpand = current.aspectRatio ? width < origMaxWidth && height < origMaxHeight && width < origWidth && height < origHeight : (width < origMaxWidth || height < origMaxHeight) && (width < origWidth || height < origHeight);
			$.extend(current, {
				dim: {
					width: getValue(width_),
					height: getValue(height_)
				},
				origWidth: origWidth,
				origHeight: origHeight,
				canShrink: canShrink,
				canExpand: canExpand,
				wPadding: wPadding,
				hPadding: hPadding,
				wrapSpace: height_ - skin.outerHeight(true),
				skinSpace: skin.height() - height
			});
			if (!iframe && current.autoHeight && height > minHeight && height < maxHeight && !canExpand) {
				inner.height("auto")
			}
		},
		_getPosition: function (onlyAbsolute) {
			var current = F.current,
				viewport = F.getViewport(),
				margin = current.margin,
				width = F.wrap.width() + margin[1] + margin[3],
				height = F.wrap.height() + margin[0] + margin[2],
				rez = {
					position: "absolute",
					top: margin[0],
					left: margin[3]
				};
			if (current.autoCenter && current.fixed && !onlyAbsolute && height <= viewport.h && width <= viewport.w) {
				rez.position = "fixed"
			} else if (!current.locked) {
				rez.top += viewport.y;
				rez.left += viewport.x
			}
			rez.top = getValue(Math.max(rez.top, rez.top + (viewport.h - height) * current.topRatio));
			rez.left = getValue(Math.max(rez.left, rez.left + (viewport.w - width) * current.leftRatio));
			return rez
		},
		_afterZoomIn: function () {
			var current = F.current;
			if (!current) {
				return
			}
			F.isOpen = F.isOpened = true;
			F.wrap.css("overflow", "visible").addClass("fancybox-opened").hide().show(0);
			F.update();
			if (current.closeClick || current.nextClick && F.group.length > 1) {
				F.inner.css("cursor", "pointer").bind("click.fb", function (e) {
					if (!$(e.target).is("a") && !$(e.target).parent().is("a")) {
						e.preventDefault();
						F[current.closeClick ? "close" : "next"]()
					}
				})
			}
			if (current.closeBtn) {
				$(current.tpl.closeBtn).appendTo(F.skin).bind("click.fb", function (e) {
					e.preventDefault();
					F.close()
				})
			}
			if (current.arrows && F.group.length > 1) {
				if (current.loop || current.index > 0) {
					$(current.tpl.prev).appendTo(F.outer).bind("click.fb", F.prev)
				}
				if (current.loop || current.index < F.group.length - 1) {
					$(current.tpl.next).appendTo(F.outer).bind("click.fb", F.next)
				}
			}
			F.trigger("afterShow");
			if (!current.loop && current.index === current.group.length - 1) {
				F.play(false)
			} else if (F.opts.autoPlay && !F.player.isActive) {
				F.opts.autoPlay = false;
				F.play(true)
			}
		},
		_afterZoomOut: function (obj) {
			obj = obj || F.current;
			$(".fancybox-wrap").trigger("onReset").remove();
			$.extend(F, {
				group: {},
				opts: {},
				router: false,
				current: null,
				isActive: false,
				isOpened: false,
				isOpen: false,
				isClosing: false,
				wrap: null,
				skin: null,
				outer: null,
				inner: null
			});
			F.trigger("afterClose", obj)
		}
	});
	F.transitions = {
		getOrigPosition: function () {
			var current = F.current,
				element = current.element,
				orig = current.orig,
				pos = {},
				width = 50,
				height = 50,
				hPadding = current.hPadding,
				wPadding = current.wPadding,
				viewport = F.getViewport();
			if (!orig && current.isDom && element.is(":visible")) {
				orig = element.find("img:first");
				if (!orig.length) {
					orig = element
				}
			}
			if (isQuery(orig)) {
				pos = orig.offset();
				if (orig.is("img")) {
					width = orig.outerWidth();
					height = orig.outerHeight()
				}
			} else {
				pos.top = viewport.y + (viewport.h - height) * current.topRatio;
				pos.left = viewport.x + (viewport.w - width) * current.leftRatio
			}
			if (F.wrap.css("position") === "fixed" || current.locked) {
				pos.top -= viewport.y;
				pos.left -= viewport.x
			}
			pos = {
				top: getValue(pos.top - hPadding * current.topRatio),
				left: getValue(pos.left - wPadding * current.leftRatio),
				width: getValue(width + wPadding),
				height: getValue(height + hPadding)
			};
			return pos
		},
		step: function (now, fx) {
			var ratio, padding, value, prop = fx.prop,
				current = F.current,
				wrapSpace = current.wrapSpace,
				skinSpace = current.skinSpace;
			if (prop === "width" || prop === "height") {
				ratio = fx.end === fx.start ? 1 : (now - fx.start) / (fx.end - fx.start);
				if (F.isClosing) {
					ratio = 1 - ratio
				}
				padding = prop === "width" ? current.wPadding : current.hPadding;
				value = now - padding;
				F.skin[prop](getScalar(prop === "width" ? value : value - wrapSpace * ratio));
				F.inner[prop](getScalar(prop === "width" ? value : value - wrapSpace * ratio - skinSpace * ratio))
			}
		},
		zoomIn: function () {
			var current = F.current,
				startPos = current.pos,
				effect = current.openEffect,
				elastic = effect === "elastic",
				endPos = $.extend({
					opacity: 1
				}, startPos);
			delete endPos.position;
			if (elastic) {
				startPos = this.getOrigPosition();
				if (current.openOpacity) {
					startPos.opacity = .1
				}
			} else if (effect === "fade") {
				startPos.opacity = .1
			}
			F.wrap.css(startPos).animate(endPos, {
				duration: effect === "none" ? 0 : current.openSpeed,
				easing: current.openEasing,
				step: elastic ? this.step : null,
				complete: F._afterZoomIn
			})
		},
		zoomOut: function () {
			var current = F.current,
				effect = current.closeEffect,
				elastic = effect === "elastic",
				endPos = {
					opacity: .1
				};
			if (elastic) {
				endPos = this.getOrigPosition();
				if (current.closeOpacity) {
					endPos.opacity = .1
				}
			}
			F.wrap.animate(endPos, {
				duration: effect === "none" ? 0 : current.closeSpeed,
				easing: current.closeEasing,
				step: elastic ? this.step : null,
				complete: F._afterZoomOut
			})
		},
		changeIn: function () {
			var current = F.current,
				effect = current.nextEffect,
				startPos = current.pos,
				endPos = {
					opacity: 1
				},
				direction = F.direction,
				distance = 200,
				field;
			startPos.opacity = .1;
			if (effect === "elastic") {
				field = direction === "down" || direction === "up" ? "top" : "left";
				if (direction === "down" || direction === "right") {
					startPos[field] = getValue(getScalar(startPos[field]) - distance);
					endPos[field] = "+=" + distance + "px"
				} else {
					startPos[field] = getValue(getScalar(startPos[field]) + distance);
					endPos[field] = "-=" + distance + "px"
				}
			}
			if (effect === "none") {
				F._afterZoomIn()
			} else {
				F.wrap.css(startPos).animate(endPos, {
					duration: current.nextSpeed,
					easing: current.nextEasing,
					complete: F._afterZoomIn
				})
			}
		},
		changeOut: function () {
			var previous = F.previous,
				effect = previous.prevEffect,
				endPos = {
					opacity: .1
				},
				direction = F.direction,
				distance = 200;
			if (effect === "elastic") {
				endPos[direction === "down" || direction === "up" ? "top" : "left"] = (direction === "up" || direction === "left" ? "-" : "+") + "=" + distance + "px"
			}
			previous.wrap.animate(endPos, {
				duration: effect === "none" ? 0 : previous.prevSpeed,
				easing: previous.prevEasing,
				complete: function () {
					$(this).trigger("onReset").remove()
				}
			})
		}
	};
	F.helpers.overlay = {
		defaults: {
			closeClick: true,
			speedOut: 200,
			showEarly: true,
			css: {},
			locked: !isTouch,
			fixed: true
		},
		overlay: null,
		fixed: false,
		el: $("html"),
		create: function (opts) {
			var parent;
			opts = $.extend({}, this.defaults, opts);
			if (this.overlay) {
				this.close()
			}
			parent = F.coming ? F.coming.parent : opts.parent;
			this.overlay = $('<div class="fancybox-overlay"></div>').appendTo(parent && parent.length ? parent : "body");
			this.fixed = false;
			if (opts.fixed && F.defaults.fixed) {
				this.overlay.addClass("fancybox-overlay-fixed");
				this.fixed = true
			}
		},
		open: function (opts) {
			var that = this;
			opts = $.extend({}, this.defaults, opts);
			if (this.overlay) {
				this.overlay.unbind(".overlay").width("auto").height("auto")
			} else {
				this.create(opts)
			}
			if (!this.fixed) {
				W.bind("resize.overlay", $.proxy(this.update, this));
				this.update()
			}
			if (opts.closeClick) {
				this.overlay.bind("click.overlay", function (e) {
					if ($(e.target).hasClass("fancybox-overlay")) {
						if (F.isActive) {
							F.close()
						} else {
							that.close()
						}
						return false
					}
				})
			}
			this.overlay.css(opts.css).show()
		},
		close: function () {
			W.unbind("resize.overlay");
			if (this.el.hasClass("fancybox-lock")) {
				$(".fancybox-margin").removeClass("fancybox-margin");
				this.el.removeClass("fancybox-lock");
				W.scrollTop(this.scrollV).scrollLeft(this.scrollH)
			}
			$(".fancybox-overlay").remove().hide();
			$.extend(this, {
				overlay: null,
				fixed: false
			})
		},
		update: function () {
			var width = "100%",
				offsetWidth;
			this.overlay.width(width).height("100%");
			if (IE) {
				offsetWidth = Math.max(document.documentElement.offsetWidth, document.body.offsetWidth);
				if (D.width() > offsetWidth) {
					width = D.width()
				}
			} else if (D.width() > W.width()) {
				width = D.width()
			}
			this.overlay.width(width).height(D.height())
		},
		onReady: function (opts, obj) {
			var overlay = this.overlay;
			$(".fancybox-overlay").stop(true, true);
			if (!overlay) {
				this.create(opts)
			}
			if (opts.locked && this.fixed && obj.fixed) {
				obj.locked = this.overlay.append(obj.wrap);
				obj.fixed = false
			}
			if (opts.showEarly === true) {
				this.beforeShow.apply(this, arguments)
			}
		},
		beforeShow: function (opts, obj) {
			if (obj.locked && !this.el.hasClass("fancybox-lock")) {
				if (this.fixPosition !== false) {
					$("*:not(object)").filter(function () {
						return $(this).css("position") === "fixed" && !$(this).hasClass("fancybox-overlay") && !$(this).hasClass("fancybox-wrap")
					}).addClass("fancybox-margin")
				}
				this.el.addClass("fancybox-margin");
				this.scrollV = W.scrollTop();
				this.scrollH = W.scrollLeft();
				this.el.addClass("fancybox-lock");
				W.scrollTop(this.scrollV).scrollLeft(this.scrollH)
			}
			this.open(opts)
		},
		onUpdate: function () {
			if (!this.fixed) {
				this.update()
			}
		},
		afterClose: function (opts) {
			if (this.overlay && !F.coming) {
				this.overlay.fadeOut(opts.speedOut, $.proxy(this.close, this))
			}
		}
	};
	F.helpers.title = {
		defaults: {
			type: "float",
			position: "bottom"
		},
		beforeShow: function (opts) {
			var current = F.current,
				text = current.title,
				type = opts.type,
				title, target;
			if ($.isFunction(text)) {
				text = text.call(current.element, current)
			}
			if (!isString(text) || $.trim(text) === "") {
				return
			}
			title = $('<div class="fancybox-title fancybox-title-' + type + '-wrap">' + text + "</div>");
			switch (type) {
				case "inside":
					target = F.skin;
					break;
				case "outside":
					target = F.wrap;
					break;
				case "over":
					target = F.inner;
					break;
				default:
					target = F.skin;
					title.appendTo("body");
					if (IE) {
						title.width(title.width())
					}
					title.wrapInner('<span class="child"></span>');
					F.current.margin[2] += Math.abs(getScalar(title.css("margin-bottom")));
					break
			}
			title[opts.position === "top" ? "prependTo" : "appendTo"](target)
		}
	};
	$.fn.fancybox = function (options) {
		var index, that = $(this),
			selector = this.selector || "",
			run = function (e) {
				var what = $(this).blur(),
					idx = index,
					relType, relVal;
				if (!(e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) && !what.is(".fancybox-wrap")) {
					relType = options.groupAttr || "data-fancybox-group";
					relVal = what.attr(relType);
					if (!relVal) {
						relType = "rel";
						relVal = what.get(0)[relType]
					}
					if (relVal && relVal !== "" && relVal !== "nofollow") {
						what = selector.length ? $(selector) : that;
						what = what.filter("[" + relType + '="' + relVal + '"]');
						idx = what.index(this)
					}
					options.index = idx;
					if (F.open(what, options) !== false) {
						e.preventDefault()
					}
				}
			};
		options = options || {};
		index = options.index || 0;
		if (!selector || options.live === false) {
			that.unbind("click.fb-start").bind("click.fb-start", run)
		} else {
			D.undelegate(selector, "click.fb-start").delegate(selector + ":not('.fancybox-item, .fancybox-nav')", "click.fb-start", run)
		}
		this.filter("[data-fancybox-start=1]").trigger("click");
		return this
	};
	D.ready(function () {
		var w1, w2;
		if ($.scrollbarWidth === undefined) {
			$.scrollbarWidth = function () {
				var parent = $('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),
					child = parent.children(),
					width = child.innerWidth() - child.height(99).innerWidth();
				parent.remove();
				return width
			}
		}
		if ($.support.fixedPosition === undefined) {
			$.support.fixedPosition = function () {
				var elem = $('<div style="position:fixed;top:20px;"></div>').appendTo("body"),
					fixed = elem[0].offsetTop === 20 || elem[0].offsetTop === 15;
				elem.remove();
				return fixed
			}()
		}
		$.extend(F.defaults, {
			scrollbarWidth: $.scrollbarWidth(),
			fixed: $.support.fixedPosition,
			parent: $("body")
		});
		w1 = $(window).width();
		H.addClass("fancybox-lock-test");
		w2 = $(window).width();
		H.removeClass("fancybox-lock-test");
		$("<style type='text/css'>.fancybox-margin{margin-right:" + (w2 - w1) + "px;}</style>").appendTo("head")
	})
})(window, document, jQuery);
! function (e, t) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : ((e = e || self).Vimeo = e.Vimeo || {}, e.Vimeo.Player = t())
}(this, function () {
	"use strict";

	function r(e, t) {
		for (var n = 0; n < t.length; n++) {
			var r = t[n];
			r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
		}
	}
	var e = "undefined" != typeof global && "[object global]" === {}.toString.call(global);

	function i(e, t) {
		return 0 === e.indexOf(t.toLowerCase()) ? e : "".concat(t.toLowerCase()).concat(e.substr(0, 1).toUpperCase()).concat(e.substr(1))
	}

	function s(e) {
		return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(e)
	}

	function l() {
		var e, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
			n = t.id,
			r = t.url,
			o = n || r;
		if (!o) throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
		if (e = o, !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e) return "https://vimeo.com/".concat(o);
		if (s(o)) return o.replace("http:", "https:");
		if (n) throw new TypeError("“".concat(n, "” is not a valid video id."));
		throw new TypeError("“".concat(o, "” is not a vimeo.com url."))
	}
	var t = void 0 !== Array.prototype.indexOf,
		n = "undefined" != typeof window && void 0 !== window.postMessage;
	if (!(e || t && n)) throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
	var o = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
	! function (e) {
		if (!e.WeakMap) {
			var n = Object.prototype.hasOwnProperty,
				o = function (e, t, n) {
					Object.defineProperty ? Object.defineProperty(e, t, {
						configurable: !0,
						writable: !0,
						value: n
					}) : e[t] = n
				};
			e.WeakMap = function () {
				function e() {
					if (void 0 === this) throw new TypeError("Constructor WeakMap requires 'new'");
					if (o(this, "_id", "_WeakMap" + "_" + t() + "." + t()), 0 < arguments.length) throw new TypeError("WeakMap iterable is not supported")
				}

				function r(e, t) {
					if (!i(e) || !n.call(e, "_id")) throw new TypeError(t + " method called on incompatible receiver " + typeof e)
				}

				function t() {
					return Math.random().toString().substring(2)
				}
				return o(e.prototype, "delete", function (e) {
					if (r(this, "delete"), !i(e)) return !1;
					var t = e[this._id];
					return !(!t || t[0] !== e) && (delete e[this._id], !0)
				}), o(e.prototype, "get", function (e) {
					if (r(this, "get"), i(e)) {
						var t = e[this._id];
						return t && t[0] === e ? t[1] : void 0
					}
				}), o(e.prototype, "has", function (e) {
					if (r(this, "has"), !i(e)) return !1;
					var t = e[this._id];
					return !(!t || t[0] !== e)
				}), o(e.prototype, "set", function (e, t) {
					if (r(this, "set"), !i(e)) throw new TypeError("Invalid value used as weak map key");
					var n = e[this._id];
					return n && n[0] === e ? n[1] = t : o(e, this._id, [e, t]), this
				}), o(e, "_polyfill", !0), e
			}()
		}

		function i(e) {
			return Object(e) === e
		}
	}("undefined" != typeof self ? self : "undefined" != typeof window ? window : o);
	var a, f = (function (e) {
			var t, n, r;
			r = function () {
				var t, a, n, e = Object.prototype.toString,
					r = "undefined" != typeof setImmediate ? function (e) {
						return setImmediate(e)
					} : setTimeout;
				try {
					Object.defineProperty({}, "x", {}), t = function (e, t, n, r) {
						return Object.defineProperty(e, t, {
							value: n,
							writable: !0,
							configurable: !1 !== r
						})
					}
				} catch (e) {
					t = function (e, t, n) {
						return e[t] = n, e
					}
				}

				function i(e, t) {
					n.add(e, t), a || (a = r(n.drain))
				}

				function u(e) {
					var t, n = typeof e;
					return null == e || "object" != n && "function" != n || (t = e.then), "function" == typeof t && t
				}

				function c() {
					for (var e = 0; e < this.chain.length; e++) o(this, 1 === this.state ? this.chain[e].success : this.chain[e].failure, this.chain[e]);
					this.chain.length = 0
				}

				function o(e, t, n) {
					var r, o;
					try {
						!1 === t ? n.reject(e.msg) : (r = !0 === t ? e.msg : t.call(void 0, e.msg)) === n.promise ? n.reject(TypeError("Promise-chain cycle")) : (o = u(r)) ? o.call(r, n.resolve, n.reject) : n.resolve(r)
					} catch (e) {
						n.reject(e)
					}
				}

				function s(e) {
					var t = this;
					t.triggered || (t.triggered = !0, t.def && (t = t.def), t.msg = e, t.state = 2, 0 < t.chain.length && i(c, t))
				}

				function l(e, n, r, o) {
					for (var t = 0; t < n.length; t++) ! function (t) {
						e.resolve(n[t]).then(function (e) {
							r(t, e)
						}, o)
					}(t)
				}

				function f(e) {
					this.def = e, this.triggered = !1
				}

				function d(e) {
					this.promise = e, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0
				}

				function h(e) {
					if ("function" != typeof e) throw TypeError("Not a function");
					if (0 !== this.__NPO__) throw TypeError("Not a promise");
					this.__NPO__ = 1;
					var r = new d(this);
					this.then = function (e, t) {
						var n = {
							success: "function" != typeof e || e,
							failure: "function" == typeof t && t
						};
						return n.promise = new this.constructor(function (e, t) {
							if ("function" != typeof e || "function" != typeof t) throw TypeError("Not a function");
							n.resolve = e, n.reject = t
						}), r.chain.push(n), 0 !== r.state && i(c, r), n.promise
					}, this["catch"] = function (e) {
						return this.then(void 0, e)
					};
					try {
						e.call(void 0, function (e) {
							(function e(n) {
								var r, o = this;
								if (!o.triggered) {
									o.triggered = !0, o.def && (o = o.def);
									try {
										(r = u(n)) ? i(function () {
											var t = new f(o);
											try {
												r.call(n, function () {
													e.apply(t, arguments)
												}, function () {
													s.apply(t, arguments)
												})
											} catch (e) {
												s.call(t, e)
											}
										}): (o.msg = n, o.state = 1, 0 < o.chain.length && i(c, o))
									} catch (e) {
										s.call(new f(o), e)
									}
								}
							}).call(r, e)
						}, function (e) {
							s.call(r, e)
						})
					} catch (e) {
						s.call(r, e)
					}
				}
				n = function () {
					var n, r, o;

					function i(e, t) {
						this.fn = e, this.self = t, this.next = void 0
					}
					return {
						add: function (e, t) {
							o = new i(e, t), r ? r.next = o : n = o, r = o, o = void 0
						},
						drain: function () {
							var e = n;
							for (n = r = a = void 0; e;) e.fn.call(e.self), e = e.next
						}
					}
				}();
				var v = t({}, "constructor", h, !1);
				return t(h.prototype = v, "__NPO__", 0, !1), t(h, "resolve", function (n) {
					return n && "object" == typeof n && 1 === n.__NPO__ ? n : new this(function (e, t) {
						if ("function" != typeof e || "function" != typeof t) throw TypeError("Not a function");
						e(n)
					})
				}), t(h, "reject", function (n) {
					return new this(function (e, t) {
						if ("function" != typeof e || "function" != typeof t) throw TypeError("Not a function");
						t(n)
					})
				}), t(h, "all", function (t) {
					var a = this;
					return "[object Array]" != e.call(t) ? a.reject(TypeError("Not an array")) : 0 === t.length ? a.resolve([]) : new a(function (n, e) {
						if ("function" != typeof n || "function" != typeof e) throw TypeError("Not a function");
						var r = t.length,
							o = Array(r),
							i = 0;
						l(a, t, function (e, t) {
							o[e] = t, ++i === r && n(o)
						}, e)
					})
				}), t(h, "race", function (t) {
					var r = this;
					return "[object Array]" != e.call(t) ? r.reject(TypeError("Not an array")) : new r(function (n, e) {
						if ("function" != typeof n || "function" != typeof e) throw TypeError("Not a function");
						l(r, t, function (e, t) {
							n(t)
						}, e)
					})
				}), h
			}, (n = o)[t = "Promise"] = n[t] || r(), e.exports && (e.exports = n[t])
		}(a = {
			exports: {}
		}, a.exports), a.exports),
		d = new WeakMap;

	function u(e, t, n) {
		var r = d.get(e.element) || {};
		t in r || (r[t] = []), r[t].push(n), d.set(e.element, r)
	}

	function c(e, t) {
		return (d.get(e.element) || {})[t] || []
	}

	function h(e, t, n) {
		var r = d.get(e.element) || {};
		if (!r[t]) return !0;
		if (!n) return r[t] = [], d.set(e.element, r), !0;
		var o = r[t].indexOf(n);
		return -1 !== o && r[t].splice(o, 1), d.set(e.element, r), r[t] && 0 === r[t].length
	}
	var v = ["autopause", "autoplay", "background", "byline", "color", "controls", "dnt", "height", "id", "loop", "maxheight", "maxwidth", "muted", "playsinline", "portrait", "responsive", "speed", "texttrack", "title", "transparent", "url", "width"];

	function p(r) {
		var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
		return v.reduce(function (e, t) {
			var n = r.getAttribute("data-vimeo-".concat(t));
			return (n || "" === n) && (e[t] = "" === n ? 1 : n), e
		}, e)
	}

	function y(e, t) {
		var n = e.html;
		if (!t) throw new TypeError("An element must be provided");
		if (null !== t.getAttribute("data-vimeo-initialized")) return t.querySelector("iframe");
		var r = document.createElement("div");
		return r.innerHTML = n, t.appendChild(r.firstChild), t.setAttribute("data-vimeo-initialized", "true"), t.querySelector("iframe")
	}

	function m(i) {
		var a = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
			u = 2 < arguments.length ? arguments[2] : void 0;
		return new Promise(function (t, n) {
			if (!s(i)) throw new TypeError("“".concat(i, "” is not a vimeo.com url."));
			var e = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(i));
			for (var r in a) a.hasOwnProperty(r) && (e += "&".concat(r, "=").concat(encodeURIComponent(a[r])));
			var o = "XDomainRequest" in window ? new XDomainRequest : new XMLHttpRequest;
			o.open("GET", e, !0), o.onload = function () {
				if (404 !== o.status)
					if (403 !== o.status) try {
						var e = JSON.parse(o.responseText);
						if (403 === e.domain_status_code) return y(e, u), void n(new Error("“".concat(i, "” is not embeddable.")));
						t(e)
					} catch (e) {
						n(e)
					} else n(new Error("“".concat(i, "” is not embeddable.")));
					else n(new Error("“".concat(i, "” was not found.")))
			}, o.onerror = function () {
				var e = o.status ? " (".concat(o.status, ")") : "";
				n(new Error("There was an error fetching the embed code from Vimeo".concat(e, ".")))
			}, o.send()
		})
	}

	function g(e) {
		if ("string" == typeof e) try {
			e = JSON.parse(e)
		} catch (e) {
			return console.warn(e), {}
		}
		return e
	}

	function w(e, t, n) {
		if (e.element.contentWindow && e.element.contentWindow.postMessage) {
			var r = {
				method: t
			};
			void 0 !== n && (r.value = n);
			var o = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
			8 <= o && o < 10 && (r = JSON.stringify(r)), e.element.contentWindow.postMessage(r, e.origin)
		}
	}

	function b(n, r) {
		var t, e = [];
		if ((r = g(r)).event) {
			if ("error" === r.event) c(n, r.data.method).forEach(function (e) {
				var t = new Error(r.data.message);
				t.name = r.data.name, e.reject(t), h(n, r.data.method, e)
			});
			e = c(n, "event:".concat(r.event)), t = r.data
		} else if (r.method) {
			var o = function (e, t) {
				var n = c(e, t);
				if (n.length < 1) return !1;
				var r = n.shift();
				return h(e, t, r), r
			}(n, r.method);
			o && (e.push(o), t = r.value)
		}
		e.forEach(function (e) {
			try {
				if ("function" == typeof e) return void e.call(n, t);
				e.resolve(t)
			} catch (e) {}
		})
	}
	var k = new WeakMap,
		E = new WeakMap,
		Player = function () {
			function Player(u) {
				var e, c = this,
					n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
				if (function (e, t) {
						if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
					}(this, Player), window.jQuery && u instanceof jQuery && (1 < u.length && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), u = u[0]), "undefined" != typeof document && "string" == typeof u && (u = document.getElementById(u)), e = u, !Boolean(e && 1 === e.nodeType && "nodeName" in e && e.ownerDocument && e.ownerDocument.defaultView)) throw new TypeError("You must pass either a valid element or a valid id.");
				var r = u.ownerDocument.defaultView;
				if ("IFRAME" !== u.nodeName) {
					var t = u.querySelector("iframe");
					t && (u = t)
				}
				if ("IFRAME" === u.nodeName && !s(u.getAttribute("src") || "")) throw new Error("The player element passed isn’t a Vimeo embed.");
				if (k.has(u)) return k.get(u);
				this.element = u, this.origin = "*";
				var o = new f(function (i, a) {
					var e = function (e) {
						if (s(e.origin) && c.element.contentWindow === e.source) {
							"*" === c.origin && (c.origin = e.origin);
							var t = g(e.data);
							if (t && "error" === t.event && t.data && "ready" === t.data.method) {
								var n = new Error(t.data.message);
								return n.name = t.data.name, void a(n)
							}
							var r = t && "ready" === t.event,
								o = t && "ping" === t.method;
							if (r || o) return c.element.setAttribute("data-ready", "true"), void i();
							b(c, t)
						}
					};
					if (r.addEventListener ? r.addEventListener("message", e, !1) : r.attachEvent && r.attachEvent("onmessage", e), "IFRAME" !== c.element.nodeName) {
						var t = p(u, n);
						m(l(t), t, u).then(function (e) {
							var t, n, r, o = y(e, u);
							return c.element = o, c._originalElement = u, t = u, n = o, r = d.get(t), d.set(n, r), d["delete"](t), k.set(c.element, c), e
						})["catch"](a)
					}
				});
				return E.set(this, o), k.set(this.element, this), "IFRAME" === this.element.nodeName && w(this, "ping"), this
			}
			var e, t, n;
			return e = Player, (t = [{
				key: "callMethod",
				value: function (n) {
					var r = this,
						o = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
					return new f(function (e, t) {
						return r.ready().then(function () {
							u(r, n, {
								resolve: e,
								reject: t
							}), w(r, n, o)
						})["catch"](t)
					})
				}
			}, {
				key: "get",
				value: function (n) {
					var r = this;
					return new f(function (e, t) {
						return n = i(n, "get"), r.ready().then(function () {
							u(r, n, {
								resolve: e,
								reject: t
							}), w(r, n)
						})["catch"](t)
					})
				}
			}, {
				key: "set",
				value: function (n, r) {
					var o = this;
					return new f(function (e, t) {
						if (n = i(n, "set"), null == r) throw new TypeError("There must be a value to set.");
						return o.ready().then(function () {
							u(o, n, {
								resolve: e,
								reject: t
							}), w(o, n, r)
						})["catch"](t)
					})
				}
			}, {
				key: "on",
				value: function (e, t) {
					if (!e) throw new TypeError("You must pass an event name.");
					if (!t) throw new TypeError("You must pass a callback function.");
					if ("function" != typeof t) throw new TypeError("The callback must be a function.");
					0 === c(this, "event:".concat(e)).length && this.callMethod("addEventListener", e)["catch"](function () {}), u(this, "event:".concat(e), t)
				}
			}, {
				key: "off",
				value: function (e, t) {
					if (!e) throw new TypeError("You must pass an event name.");
					if (t && "function" != typeof t) throw new TypeError("The callback must be a function.");
					h(this, "event:".concat(e), t) && this.callMethod("removeEventListener", e)["catch"](function (e) {})
				}
			}, {
				key: "loadVideo",
				value: function (e) {
					return this.callMethod("loadVideo", e)
				}
			}, {
				key: "ready",
				value: function () {
					var e = E.get(this) || new f(function (e, t) {
						t(new Error("Unknown player. Probably unloaded."))
					});
					return f.resolve(e)
				}
			}, {
				key: "addCuePoint",
				value: function (e) {
					var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
					return this.callMethod("addCuePoint", {
						time: e,
						data: t
					})
				}
			}, {
				key: "removeCuePoint",
				value: function (e) {
					return this.callMethod("removeCuePoint", e)
				}
			}, {
				key: "enableTextTrack",
				value: function (e, t) {
					if (!e) throw new TypeError("You must pass a language.");
					return this.callMethod("enableTextTrack", {
						language: e,
						kind: t
					})
				}
			}, {
				key: "disableTextTrack",
				value: function () {
					return this.callMethod("disableTextTrack")
				}
			}, {
				key: "pause",
				value: function () {
					return this.callMethod("pause")
				}
			}, {
				key: "play",
				value: function () {
					return this.callMethod("play")
				}
			}, {
				key: "unload",
				value: function () {
					return this.callMethod("unload")
				}
			}, {
				key: "destroy",
				value: function () {
					var t = this;
					return new f(function (e) {
						E["delete"](t), k["delete"](t.element), t._originalElement && (k["delete"](t._originalElement), t._originalElement.removeAttribute("data-vimeo-initialized")), t.element && "IFRAME" === t.element.nodeName && t.element.parentNode && t.element.parentNode.removeChild(t.element), e()
					})
				}
			}, {
				key: "getAutopause",
				value: function () {
					return this.get("autopause")
				}
			}, {
				key: "setAutopause",
				value: function (e) {
					return this.set("autopause", e)
				}
			}, {
				key: "getBuffered",
				value: function () {
					return this.get("buffered")
				}
			}, {
				key: "getColor",
				value: function () {
					return this.get("color")
				}
			}, {
				key: "setColor",
				value: function (e) {
					return this.set("color", e)
				}
			}, {
				key: "getCuePoints",
				value: function () {
					return this.get("cuePoints")
				}
			}, {
				key: "getCurrentTime",
				value: function () {
					return this.get("currentTime")
				}
			}, {
				key: "setCurrentTime",
				value: function (e) {
					return this.set("currentTime", e)
				}
			}, {
				key: "getDuration",
				value: function () {
					return this.get("duration")
				}
			}, {
				key: "getEnded",
				value: function () {
					return this.get("ended")
				}
			}, {
				key: "getLoop",
				value: function () {
					return this.get("loop")
				}
			}, {
				key: "setLoop",
				value: function (e) {
					return this.set("loop", e)
				}
			}, {
				key: "setMuted",
				value: function (e) {
					return this.set("muted", e)
				}
			}, {
				key: "getMuted",
				value: function () {
					return this.get("muted")
				}
			}, {
				key: "getPaused",
				value: function () {
					return this.get("paused")
				}
			}, {
				key: "getPlaybackRate",
				value: function () {
					return this.get("playbackRate")
				}
			}, {
				key: "setPlaybackRate",
				value: function (e) {
					return this.set("playbackRate", e)
				}
			}, {
				key: "getPlayed",
				value: function () {
					return this.get("played")
				}
			}, {
				key: "getSeekable",
				value: function () {
					return this.get("seekable")
				}
			}, {
				key: "getSeeking",
				value: function () {
					return this.get("seeking")
				}
			}, {
				key: "getTextTracks",
				value: function () {
					return this.get("textTracks")
				}
			}, {
				key: "getVideoEmbedCode",
				value: function () {
					return this.get("videoEmbedCode")
				}
			}, {
				key: "getVideoId",
				value: function () {
					return this.get("videoId")
				}
			}, {
				key: "getVideoTitle",
				value: function () {
					return this.get("videoTitle")
				}
			}, {
				key: "getVideoWidth",
				value: function () {
					return this.get("videoWidth")
				}
			}, {
				key: "getVideoHeight",
				value: function () {
					return this.get("videoHeight")
				}
			}, {
				key: "getVideoUrl",
				value: function () {
					return this.get("videoUrl")
				}
			}, {
				key: "getVolume",
				value: function () {
					return this.get("volume")
				}
			}, {
				key: "setVolume",
				value: function (e) {
					return this.set("volume", e)
				}
			}]) && r(e.prototype, t), n && r(e, n), Player
		}();
	return e || (function () {
		var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document,
			t = [].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")),
			n = function (e) {
				"console" in window && console.error && console.error("There was an error creating an embed: ".concat(e))
			};
		t.forEach(function (t) {
			try {
				if (null !== t.getAttribute("data-vimeo-defer")) return;
				var e = p(t);
				m(l(e), e, t).then(function (e) {
					return y(e, t)
				})["catch"](n)
			} catch (e) {
				n(e)
			}
		})
	}(), function () {
		var r = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document;
		if (!window.VimeoPlayerResizeEmbeds_) {
			window.VimeoPlayerResizeEmbeds_ = !0;
			var e = function (e) {
				if (s(e.origin) && e.data && "spacechange" === e.data.event)
					for (var t = r.querySelectorAll("iframe"), n = 0; n < t.length; n++)
						if (t[n].contentWindow === e.source) {
							t[n].parentElement.style.paddingBottom = "".concat(e.data.data[0].bottom, "px");
							break
						}
			};
			window.addEventListener ? window.addEventListener("message", e, !1) : window.attachEvent && window.attachEvent("onmessage", e)
		}
	}()), Player
});

/*---------------cart drawer--------------------*/
jQuery(window).on("load", function ($) {
	if (jQuery(window).width() < 767) {
		var mobile_head = jQuery(".wrraper_header.mobile_header").height();
		var cart_head = jQuery(".cart_drawer_inner .cart_head").height();
		var footer_pos = jQuery(".cart_drawer_inner .cart_drawer_pos").height();
		var windowing_height = jQuery(window).height();
		var total_height_val = cart_head + footer_pos + mobile_head;
		jQuery(".cart_body").css("height", windowing_height - total_height_val)
	}
	if (jQuery(window).width() > 767) {
		var cart_head = jQuery(".cart_drawer_inner .cart_head").height();
		var footer_pos = jQuery(".cart_drawer_inner .cart_drawer_pos").height();
		var windowing_height = jQuery(window).height();
		var total_height_val = cart_head + footer_pos;
		jQuery(".cart_body").css("height", windowing_height - total_height_val)
	}
	if (jQuery(window).width() > 767) {
		jQuery(".thumbnail_images ").css({
			width: jQuery(".thumbnail_images .slick-list.draggable").width()
		});
		jQuery(window).resize(function () {
			jQuery(".thumbnail_images ").css({
				width: jQuery(".thumbnail_images .slick-list.draggable").width()
			})
		})
	}
	jQuery(".cart_drawer_inner .cart_body .cart_row").each(function () {
		var cart_id = jQuery(this).find(".cart_meta a").attr("data-id");
		var get_title = jQuery(this).find(".cart_meta h4").html();
		jQuery(".complte_product_options li").each(function () {
			var curr_this = jQuery(this);
			var chk_id = jQuery(this).attr("data-id");
			if (cart_id == chk_id) {
				jQuery(curr_this).parents(".product_bl_out").addClass("added_pro khulja");
				setTimeout(function () {
					jQuery(curr_this).parents(".product_bl_out").removeClass("khulja")
				}, 2e3);
				var colour_val = jQuery(curr_this).attr("data-color");
				var size_val = jQuery(curr_this).attr("data-size");
				var chain_val = jQuery(curr_this).attr("data-chain");
				var combined_size_chain = size_val + "-" + chain_val
			}
		})
	});
	jQuery(".site-header__icon.site-header__cart").click(function () {
		jQuery("body,html").addClass("remove_overflow");
		setTimeout(function () {
			jQuery(".cart_drawer_pos").css({
				display: "block",
				opacity: "1",
				transition: "0.5s"
			})
		}, 500);
		jQuery("#cart_drawer_overlay").css({
			display: "block",
			opacity: "0.5",
			transition: "0.5s"
		});
		jQuery("#cart_drawer_content,.cart_drawer_pos").css({
			right: "0%",
			transition: "0.5s"
		})
	});
	jQuery("#cart_drawer_overlay").click(function () {
		jQuery("#cart_drawer_overlay").css({
			display: "none",
			opacity: "0",
			transition: "0.5s"
		});
		jQuery("#cart_drawer_content,.cart_drawer_pos").css({
			right: "-200%",
			transition: "0.5s"
		});
		jQuery("body,html").removeClass("remove_overflow");
		jQuery("#Div4").css({
			display: "none",
			transition: "0.5s"
		});
		jQuery("#Div3").css({
			display: "block",
			transition: "0.5s"
		})
	});
	jQuery("#Div4").click(function () {
		jQuery("body,html").removeClass("remove_overflow");
		jQuery("#cart_drawer_content,.cart_drawer_pos").css({
			right: "-200%",
			transition: "0.5s"
		});
		jQuery("#cart_drawer_overlay").css({
			display: "none",
			opacity: "0.5",
			transition: "0.5s"
		})
	});
	jQuery(document).on("click", ".product_bl_price > a", function (evt) {
		evt.preventDefault();
		jQuery(this).parents(".product_bl_out").toggleClass("khulja label")
	})
});
/*--------------------End cart drawer--------------------*/

/*--------------------Mega menu drawer-------------------*/
$(document).ready(function () {
	var btn = $(".this_is_not_click li"),
		info = $(".infooo");
	btn.hover(function (e) {
		var index = $(this).index();
		info.hide();
		info.eq(index).show(); 
		$(".mega__menu_sidebarr li").removeClass("active_href");
		$(this).addClass("active_href")
	});
	$(".product_grid_content_sub_heading").find("h4:contains('STACK + SAVE')").css("color", "#1DB954");
	$(".product_grid_content_sub_heading").find("h4:contains('BUNDLE + SAVE')").css("color", "#1DB954");
	$(".product_grid_content_sub_heading").find("h4:contains('BUNDLES + SETS')").css("color", "#1DB954");
	$(".product_grid_content_sub_heading").find("h4").css("color", "#a40000");
	$(".coll_box_meta").find(".coll_sub:contains('STACK + SAVE')").css("color", "#1DB954");
	$(".coll_box_meta").find(".coll_sub:contains('BUNDLE + SAVE')").css("color", "#1DB954");
	$(".coll_box_meta").find(".coll_sub:contains('BUNDLES + SETS')").css("color", "#1DB954");
	$(".coll_box_meta").find("h4").css("color", "#a40000")
});
$(".this_is_not_click li").click(function (event) {
	e.preventDefault()
});


if ($(window).width() < 768) {
	$(".slider_mobile_on").slick({
		dots: true,
		infinite: true,
		arrows: false,
		speed: 300,
		slidesToShow: 1,
		centerMode: true,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 750,
			settings: {
				initialSlide: 1
			}
		}]
	})
}
/*-----------------End Mega menu drawer---------------------*/

/*-----------------Slick slider header-----------------------*/
$(function () {
	$('.slide_bar ul').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: true
	});

	$('.slide_bar').show();
});
$(function () {
	$('.homepage_slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: false
	});

	$('.slide_bar').show();
});
/*-----------------End Slick slider header--------------------*/
/*---------------------------- Collections page Mobile Slider -----------------------------------*/                                     
jQuery(document).ready(function($) {
    if ($(window).width() < 767) {
        $(".new_coll_grid").slick({
            centerMode: true,
            centerPadding: "50px",
            dots: true,
            slidesToShow: 1,
            infinite: true
        });
        $(".new_coll_grid").slick("slickGoTo", 1)
    } else {
        $(".new_coll_grid.slider_men_chains").slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3
        })
    }   
});
/*---------------------------- End Collections page Mobile Slider -----------------------------------*/ 


/*-----------------------------Slick slider product page----------------------*/  
$(function () {
    $("#product___carousel").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        arrows: true,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });
    $(".responsive").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]
    });
    $(".footer-nav .footer-nav__title-wrapper").click(function() {
        $(this).parents(".footer-nav").toggleClass("accordion_active");
        $(".footer-nav").not($(this).parents(".footer-nav")).removeClass("accordion_active")
    });
    $(".product_shop_outer").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: false
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 320,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });
    $(".main_image").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".thumbnail_images",
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows: true,
                dots: false,
                fade: false
            }
        }]
    });
    $(".thumbnail_images").slick({
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 1,
        asNavFor: ".main_image",
        dots: false,
        vertical: true,
        focusOnSelect: true,
        arrows: true,
        responsive: [{
            breakpoint: 768,
            settings: {
                vertical: false,
                arrows: true
            }
        }],
        onAfterChange: function(slide, index) {
            console.log("chl" + index);
            if (index === 5) {
                $(".slick-next").css("pointer-events", "none")
            } else {
                $(".slick-next").css("pointer-events", "all")
            }
        }
    })
});
/*-----------------------------End Slick slider product page----------------------*/    
/*-----------------------------on select on cart page ----------------------------*/
$(".single-option-selector-product-template").change(function() {
    $("#addToCart-product-templates").css("pointer-events", "all").attr("enabled");
    $("#addToCart-product-templatess").css("pointer-events", "all").attr("enabled");
    $("#addToCart-product-templates").css("background-color", "#000");
    $("#addToCart-product-templatess").css("background-color", "#000"); 
    var optionid = $(this).children(":selected").val();
  	$("select#ProductSelect-product-template option").each(function () {
      var val = $(this).text();      
      $(this).removeAttr("selected","selected");
      console.log(optionid);
      console.log(val);
      if(val.includes(optionid)){
        console.log($(this).text());
        $(this).attr("selected","selected");
        $('.display_block').html('<span class="display_block"> Length: <span class="variant_value">'+val+'</span></span>');
      }
    });
    $(".type_vendor span.weight_chk").each(function(index) {
        var getidss = $(this).attr("id");
      
      if (optionid.indexOf(' ')>=0)
      {
        optionid = optionid.replace(/\s+/g, '')
      }
        if (optionid === getidss) {
            $("span[id='" + optionid + "']").css("display", "inline-block");
            $("span[id='" + optionid + "']").siblings(".weight_chk").css("display", "none")
        }
    });
    
    $(this).parent("div").find(".variant_value").text($(this).val());
    $(".single-option-selector-product-template option").remove(".for_remove_d");
    $(".variant_value").show();
    $(".variant_value_remove").css("display", "none");
    var this_is_content = $("#addToCart-product-templates").text();
    if (this_is_content == "Add to cart") {
        $("#addToCart-product-templates").removeClass("pro-unavailable")
    } else {
        $("#addToCart-product-templates").addClass("pro-unavailable")
    }
});  
  
/*------------------------------End On select on cart page-------------------------*/
/*------------------------------On select button show and hide --------------------*/
$("select#ProductSelect-product-template").change(function() {
    var capacityValue = $(this).find(":selected").data("inventory");
    if (capacityValue == "0") {
        $(".sold_cart").removeClass("hide");
        $(".available_cart").addClass("hide")
    } else {
        $(".sold_cart").addClass("hide");
        $(".available_cart").removeClass("hide")
    }
});
  var abc = $('button#addToCart-product-templates').text();

  abc = abc.replace(/\s+/g, '');
  var xyd = "Soldout";
  if(abc.indexOf(xyd) != -1)
  {

    $('button#addToCart-product-templates').css("background-color", "rgb(138, 146, 154)");
    $('button#addToCart-product-templatess').css("background-color", "rgb(138, 146, 154)");

  }
  
  
/*-------------------------------End On select button show and hide ---------------*/

/*---------------------------End Product page ----------------------------*/
/*---------------------------Show Hide datials data----------------------------*/
  $(".tb_click").click(function() {
    $(this).parents(".tb_group").toggleClass("open_toggle");
    $(".tb_group").not(jQuery(this).parents(".tb_group")).removeClass("open_toggle")
  });
/*---------------------------End Show hide detail data----------------------*/
 
/*---------------------Add to cart and conditions---------------------------------------*/
jQuery(document).ready(function($) {
    $(".mobile_star a").click(function(e) {
        e.preventDefault();
        $("html, body").animate({
            scrollTop: $("#product_page_slider").offset().top - 119
        }, 2e3)
    });
    $("#cart_drawer_overlay").click(function() {
        $("#cart_drawer_overlay").css({
            display: "none",
            opacity: "0",
            transition: "0.5s"
        });
        jQuery("body,html").removeClass("remove_overflow");
        $("#cart_drawer_content,.cart_drawer_pos").css({
            right: "-200%",
            transition: "0.5s"
        });
        $("#Div4").css({
            display: "none",
            transition: "0.5s"
        });
        $("#Div3").css({
            display: "block",
            transition: "0.5s"
        })
    });
    $(".product-form__cart-submit").click(function() {
        $("#cart_drawer_content").addClass("hideedrawer");
//         $(".cart_drawer_pos").css({
//             display: "none"
//         });
        $("#Div4").css({
            display: "none",
            transition: "0.5s"
        });
        $("#Div3").css({
            display: "block",
            transition: "0.5s"
        });
        setTimeout(function() {
            $("#cart_drawer_content").removeClass("hideedrawer")
        }, 1e3)
    });
    $("#Div4").click(function() {
        jQuery("body,html").removeClass("remove_overflow");
        $("#cart_drawer_content,.cart_drawer_pos").css({
            right: "-200%",
            transition: "0.5s"
        });
        $("#cart_drawer_overlay").css({
            display: "none",
            opacity: "0.5",
            transition: "0.5s"
        })
    });
  
    $(".collection-hero-mobile-selector-inner").click(function() {
        $(".collection-hero-mobile-selector-inner").toggleClass("active");
        $(".js-mobile-collections-list").slideToggle()
    });
  
    jQuery(".essentail_head a").click(function(e) {
        jQuery(this).addClass("active");
        jQuery(".essentail_head a").not(jQuery(this)).removeClass("active");
        e.preventDefault();
        var anch_href = jQuery(this).attr("href");
        jQuery("div" + anch_href).addClass("active");
        jQuery(".ess_i").not(jQuery("div" + anch_href)).removeClass("active")
    });
  
    var cart_items_html = "";

    function loadcart() {
        jQuery.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function(cart_data) {
                console.log(cart_data);
                jQuery(".cart_body").html("");
                if (cart_data.item_count == 0) {
                    jQuery(".cart_below_wrapper").addClass("disp_hide");
                    jQuery(".site-header__cart-count,.cart_btn_wrapper,.checkout_head").addClass("hide");
                    jQuery(".cart_empty,.checkout_empty").removeClass("hide")
                } else {
                    jQuery(".cart_below_wrapper").removeClass("disp_hide");
                    jQuery(".site-header__cart-count,.cart_btn_wrapper,.checkout_head").removeClass("hide");
                    jQuery(".cart_empty,.checkout_empty").addClass("hide")
                }
                var engrv_text;
                var engra_veclass;
              	/* START TRYNOW CODE */
              	var trynow_total_sd = 0;
                jQuery.each(cart_data.items, function(index, item) {
                  	let trynow_item_sd = "";
                  	console.log(item.properties.TryNow )
                    if(item.properties.TryNow == "true"){
                    	trynow_total_sd += (item.price * item.quantity);
                      	trynow_item_sd = "<p class='try_at_home_cart'>Try at Home for Free</p>";
                    }
                    if (item.properties) {
                        engrv_text = item.properties.engraving_text
                    }
                    if (item.product_title.indexOf("Engrave") != -1) {
                        engra_veclass = "engraving_product"
                    } else {
                        engra_veclass = ""
                    }
                    cart_items_html = '<div class="cart_row ' + engra_veclass + '" data-title="' + item.product_title + '" ><div class="cart_row_in"><div class="cart_img"><a href="' + item.url + '" class="cart__image"><img src="' + item.image + '" alt="' + item.product_title + '"></a></div><div class="cart_meta"><h4>' + item.product_title + '</h4><p class="crat_type" data-type="' + engrv_text + '">Engraving: ' + engrv_text + '</p><h5 data-value="' + item.variant_title + '">' + item.variant_title + "</h5>" + trynow_item_sd + "<p><span class='cart_trynow_noprice'>" + (item.properties.TryNow == "true" ? "$0</span> (<span class='cart_trynow_price'>" + theme.Currency.formatMoney(item.price, theme.moneyFormat) + "</span> if kept)" : theme.Currency.formatMoney(item.price, theme.moneyFormat)) + '</p><a data-id="' + item.key + '" class="cart_remove">Remove</a></div><div class="cart_quantity"><button class="js_quantity js_minus"><i class="fa fa-minus"></i></button><input type="text" id="cart_quantity" value="' + item.quantity + '" /> <button class="js_quantity js_plus"><i class="fa fa-plus"></i></button></div></div></div>';
                    jQuery(".cart_body").append(cart_items_html)
                });
              	if(trynow_total_sd > 0){
                  	
                	jQuery(".cart_subtotla").html("<span class='subtotal_trynow_noprice'>"+ theme.Currency.formatMoney((cart_data.items_subtotal_price - trynow_total_sd), theme.moneyFormat) + " </span> (<span class='subtotal_trynow_price'>" + theme.Currency.formatMoney(cart_data.items_subtotal_price, theme.moneyFormat) + " </span>if kept)");
                  	jQuery(".trynow-checkout-handler").attr("href", "https://jaxxon.trynowcheckout.com/customer-information?shop=jaxxon.com&token="+cart_data.token);
                  	jQuery(".trynow_side_cart_message").show();
                }else{
                  
                	jQuery(".cart_subtotla").html(theme.Currency.formatMoney(cart_data.items_subtotal_price, theme.moneyFormat));
                  	jQuery(".trynow-checkout-handler").attr("href", "/checkout");
                	jQuery(".trynow_side_cart_message").hide();
                }
                /* END TRYNOW CODE */
              	if (jQuery(window).width() < 767) {
                    var mobile_head = jQuery(".wrraper_header.mobile_header").height();
                    var cart_head = jQuery(".cart_drawer_inner .cart_head").height();
                    var footer_pos = jQuery(".cart_drawer_inner .cart_drawer_pos").height();
                  	/* START TRYNOW CODE */
                    var trynow_message = 0;
                  	if(trynow_total_sd > 0){
                      trynow_message = jQuery(".trynow_side_cart_message").height();
                    }
                    var windowing_height = jQuery(window).height();
                    var total_height_val = cart_head + footer_pos + mobile_head + trynow_message;
                  	/* END TRYNOW CODE */
                    jQuery(".cart_body").css("height", windowing_height - total_height_val)
                }
                if (jQuery(window).width() > 767) {
                    var cart_head = jQuery(".cart_drawer_inner .cart_head").height();
                    var footer_pos = jQuery(".cart_drawer_inner .cart_drawer_pos").height();
                  	/* START TRYNOW CODE */
                    var trynow_message = 0;
                  	if(trynow_total_sd > 0){
                      trynow_message = jQuery(".trynow_side_cart_message").height();
                    }
                    var windowing_height = jQuery(window).height();
                    var total_height_val = cart_head + footer_pos + trynow_message;
                  	/* END TRYNOW CODE */
                    jQuery(".cart_body").css("height", windowing_height - total_height_val)
                }
            }
        });
        jQuery(".cart_body").addClass("finishing_loading")
    }
    jQuery(".site-header__icon.site-header__cart").click(function(ev) {
        ev.preventDefault();
        loadcart()
       
    });
 
  
  jQuery(".product-form__cart-submit").click(function(ev) {
        ev.preventDefault(); 
      	
        var dataform = jQuery(this);
        var cs_form_js = jQuery("#your-Engraving_text").val();
        var get_product_id = jQuery(".product-single__title").html();
      	var value = $('#SingleOptionSelector-1').val();
      	if(value == 'pleaseselect'){
          $(".product-form__cart-submit").addClass('animate_button');		  
          setTimeout(function () { 
            $(".product-form__cart-submit").removeClass('animate_button');            
          }, 1000);
        
        }else{        
        
        if (cs_form_js) {  
         
            jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: jQuery(dataform).parents("form").serialize(),
                success: function(data, textStatus, xhr) {
                    jQuery.ajax({
                        type: "POST",
                        url: "https://hometryon.co/engraving/index.php",
                        data: {
                            step1val1: cs_form_js,
                            send_product_title: get_product_id
                        },
                        dataType: "JSON",
                        crossDomain: true,
                        success: function(data) {
                            $.each(JSON.parse(data), function(i, v) {
                                var abc = v.variants;
                                $.each(abc, function(l, m) {
                                    console.log("Key: " + m.id);
                                    var varinattt_id = m.id;
                                    var data = {
                                        quantity: 1,
                                        id: varinattt_id,
                                        properties: {
                                            engraving_text: cs_form_js,
                                            associated_product: get_product_id
                                        }
                                    };
                                    jQuery.ajax({
                                        type: "POST",
                                        url: "/cart/add.js",
                                        dataType: "json",
                                        data: data,
                                        success: function(data) {
                                            if (data) {
                                                loadcart();
                                                jQuery("body").addClass("slide-in-right");
                                                jQuery(".cart_drawer_pos").css({
                                                    right: "0%",
                                                    transition: "0.5s"
                                                })
                                            }
                                        }
                                    })
                                })
                            })
                        }
                    })
                }
            })
        } else {
            jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: jQuery(dataform).parents("form").serialize(),
                success: function(data, textStatus, xhr) {
                  
                    loadcart();
                    jQuery("body").addClass("slide-in-right");
                    jQuery("body,html").addClass("remove_overflow");
                    jQuery(".cart_drawer_pos").css({
                        right: "0",
                        transition: "0.5s"
                    });
                    $("#cart_drawer_content,.cart_drawer_pos").css({
                        right: "0%",
                        transition: "0.5s",
                        display: "block",
                    });
                    jQuery("body,html").addClass("remove_overflow");
                    $("#cart_drawer_overlay").css({
                        display: "block",
                        opacity: "0.5",
                        transition: "0.5s"
                    })
               		/* START TRYNOW CODE */
//                     setTimeout(function(){changeUpsellsTN(jQuery(dataform).parents("form").serializeArray());}, 500);
                    /* END TRYNOW CODE */
                }
            })
        }
        }
        return false
    });
    jQuery(document).on("click", ".product_addcartbelow a", function(e) {
        e.preventDefault();
        var get_var_id = jQuery(this).parents(".grid__item.hover_view").find("ul.color_swatches li.border_none a").data("id");
        console.log(get_var_id);
        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: "quantity=1&id=" + get_var_id,
            success: function(data, textStatus, xhr) {
                loadcart()
            }
        });
        jQuery("body").addClass("slide-in-right");
        jQuery("body,html").addClass("remove_overflow");
        jQuery("#cart_drawer_overlay").css({
            display: "block",
            opacity: "0.5",
            transition: "0.5s"
        });
        jQuery("#cart_drawer_content,.cart_drawer_pos").css({
            right: "0%",
            transition: "0.5s"
        })
    });
    jQuery(document).on("click", ".cart_meta a", function(e) {
        var cart_items_html = "";
        e.preventDefault();
        var data_id = jQuery(this).data("id");
        jQuery(".complte_product_options li").each(function() {
            var curr_this = jQuery(this);
            var chk_id = jQuery(this).attr("data-id");
            if (data_id == chk_id) {
                jQuery(curr_this).parents(".product_bl_out").removeClass("added_pro khulja");
                jQuery(curr_this).parents(".product_bl_out").find("ul.size_options_utl li").removeClass("fill_color")
            }
        });
        jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
                quantity: 0,
                id: data_id
            },
            success: function(data) {
                loadcart()
            }
        })
    });
    jQuery(document).on("click", ".cart_quantity button", function(e) {
        e.preventDefault();
        var cuur_this = parseInt(jQuery(this).parents(".cart_row").find("input").val());
        var new_this;
        if ($(this).hasClass("js_plus")) {
            $(this).parents(".cart_row").find("input").val(cuur_this + 1)
        } else {
            $(this).parents(".cart_row").find("input").val(cuur_this - 1)
        }
        var cuure = jQuery(this);
        var varaint_id = jQuery(this).parents(".cart_row").find(".cart_meta > a").data("id");
        var counte_qua = jQuery(this).parents(".cart_row").find("input").val();
        if (counte_qua > 0) {
            jQuery.ajax({
                type: "POST",
                url: "/cart/change.js",
                dataType: "json",
                data: {
                    quantity: counte_qua,
                    id: varaint_id
                },
                success: function(data) {
                    loadcart();
                    jQuery(".cart_subtotla").html(theme.Currency.formatMoney(data.items_subtotal_price, theme.moneyFormat))
                }
            })
        } else {
            jQuery.ajax({
                type: "POST",
                url: "/cart/change.js",
                dataType: "json",
                data: {
                    quantity: 0,
                    id: varaint_id
                },
                success: function(data) {
                    jQuery(".complte_product_options li").each(function() {
                        var curr_this = jQuery(this);
                        var chk_id = jQuery(this).attr("data-id");
                        if (varaint_id == chk_id) {
                            jQuery(curr_this).parents(".product_bl_out").removeClass("added_pro khulja");
                            jQuery(curr_this).parents(".product_bl_out").find("ul.size_options_utl li").removeClass("fill_color")
                        }
                    });
                    loadcart()
                }
            })
        }
    });
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split("&"),
            sParameterName, i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split("=");
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1])
            }
        }
    };
    jQuery(document).on("click", ".deatisl_section_form a", function() {
        var chk_line_item_has = jQuery(this).parents(".main-content").find(".product-single__meta form .product_types").val();
        var anchor_url = getUrlParameter("variant");
        console.log(anchor_url);
        jQuery(this).attr("data-id", anchor_url);
        var anchor_id = jQuery(this).attr("data-id");
        if (chk_line_item_has) {
            var data = {
                quantity: 1,
                id: anchor_id,
                properties: {
                    "Product Type": chk_line_item_has
                }
            };
            jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: data,
                success: function(data, textStatus, xhr) {
                    loadcart()
                }
            })
        } else {
            jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: {
                    quantity: 1,
                    id: anchor_id
                },
                success: function(data, textStatus, xhr) {
                    loadcart()
                }
            })
        }
        jQuery("body").addClass("slide-in-right");
        jQuery("body,html").addClass("remove_overflow");
        jQuery(".cart_drawer_pos").css({
            right: "0",
            transition: "0.5s"
        });
        $("#cart_drawer_content,.cart_drawer_pos").css({
            right: "0%",
            transition: "0.5s"
        });
        jQuery("body,html").addClass("remove_overflow");
        $("#cart_drawer_overlay").css({
            display: "block",
            opacity: "0.5",
            transition: "0.5s"
        })
    })
});
/*-----------------------------End Add to cart--------------------*/
  
/*----------------------Product page question answer-------------------*/  
$(window).load(function() {
    $(".ask_que").click(function() {
        $("div#ask_ques").show()
    });
    $("div#ask_ques .ask_Header span").click(function() {
        $("div#ask_ques").hide()
    });
    $(".review_write").click(function() {
        $("div#review_write").show()
    });
    $("div#review_write .ask_Header span").click(function() {
        $("div#review_write").hide()
    })
});
/*----------------------End Product page question answer-------------------*/    


$("ul.tab li:first-child").addClass("active");
$(".tab-content").hide();
$(".tab-content:first").show();
$("ul.tab li").click(function() {
    $("ul.tab li").removeClass("active");
    $(this).addClass("active");
    $(".tab-content").hide();
    var activeTab = $(this).find("a").attr("href");
    $(activeTab).show();
    return false
});
$(window).load(function() {
    $(".ask_que").click(function() {
        $("div#ask_ques").show()
    });
    $("div#ask_ques .ask_Header span").click(function() {
        $("div#ask_ques").hide()
    });
    $(".review_write").click(function() {
        $("div#review_write").show()
    });
    $("div#review_write .ask_Header span").click(function() {
        $("div#review_write").hide()
    })
});
$(document).ready(function() {
    var lis = $(".inner .review_block_product");
    for (var i = 0; i < lis.length; i += 4) {
        lis.slice(i, i + 4).wrapAll("<div class='unique" + i + " final_data'></div>")
    }
    $("#pagination-container li:nth-child(1)").parent().append("<li><a class='page-link'>4</a></li><li><a class='page-link'>5</a></li>");
    $(".final_data.active").show();
    setTimeout(function() {
        $(".afterpay-paragraph").find(".afterpay-text2").append("</br>");
        $(".unique0").addClass("active");
        $(".final_data.active").show();
        $("li.disabeld.slide.last-dif").addClass("slide_block")
    }, 1e3);
    $("#review_block_product").append('<div id="pagination-container"><ul class=""><li class="first"><a class="page-link prev">&lt;</a></li><li class="second active tt slide"><a class="page-link">1</a></li><li class="third tt slide"><a class="page-link">2</a></li><li class="fourth tt slide"><a class="page-link">3</a></li><li class="disabeld slide">4</li> <li class="disabeld slide">5</li> <li class="disabeld slide last-dif">6</li> <li class="disabeld zzz slide last-dif">7</li><li class="last"><a class="page-link next">&gt;</a></li></ul></div>');
    $("#pagination-container .tt").click(function() {
        $(this).addClass("active");
        $(this).addClass("active").siblings().removeClass("active")
    });
    $(".second").click(function() {
        $("html, body").animate({
            scrollTop: $("#review_block_product").offset().top
        }, 1e3);
        $(".unique0").show(1500);
        $(".unique0").prevAll().hide(1500);
        $(".unique0").nextAll().hide(1500)
    });
    $(".third").click(function() {
        $("html, body").animate({
            scrollTop: $("#review_block_product").offset().top
        }, 1e3);
        $(".unique4").fadeIn();
        $(".unique4").prevAll().fadeOut();
        $(".unique4").nextAll().fadeOut()
    });
    $(".fourth").click(function() {
        $("html, body").animate({
            scrollTop: $("#review_block_product").offset().top
        }, 1e3);
        $(".unique8").fadeIn();
        $(".unique8").prevAll().fadeOut();
        $(".unique8").nextAll().fadeOut()
    });
    $(".first").click(function() {
        $("html, body").animate({
            scrollTop: $("#review_block_product").offset().top
        }, 1e3);
        $(".unique0").fadeIn();
        $(".unique0").prevAll().fadeOut();
        $(".unique0").nextAll().fadeOut()
    });
    $(".first").click(function() {
        $(".tt.active").addClass("dummy");
        $(".tt.active").removeClass("active");
        if ($(".tt").hasClass("dummy")) {
            $(".dummy").prev().addClass("active");
            $(".tt").removeClass("dummy");
            $(".tt.active").trigger("click")
        }
        $("li.disabeld.last-dif").addClass("slide_block");
        $(".second").show();
        $(".third").show()
    });
    $(".last").click(function() {
        $(".tt.active").addClass("dummy");
        $(".tt.active").removeClass("active");
        if ($(".tt").hasClass("dummy")) {
            $(".dummy").next().addClass("active");
            $(".tt").next().next().addClass("active");
            $(".tt").removeClass("dummy");
            $(".tt.active").trigger("click");
            $(".last-dif:nth-child(1)").show();
            $("li.disabeld.last-dif").removeClass("slide_block");
            $(".second").hide();
            $(".third").hide()
        }
    });
    var width = $(window).width();
    if (width <= 480) {
        $("li.disabeld").hide();
        $(".last").click(function() {
            $(".disabeld").removeClass("active");
            $("#pagination-container li:not(.disabeld)").hide();
            $("#pagination-container li.disabeld").show();
            $(this).show();
            $(".first").show()
        });
        $(".first").click(function() {
            $("#pagination-container li:not(.disabeld)").show();
            $("#pagination-container li.disabeld").hide();
            $(this).show();
            $(".last").show()
        })
    } else {}
});  
  
/*----------------Product page size guide--------------------------*/
jQuery(".fancy_triggered,.fancy_trigger").click(function(et) {
    et.preventDefault();
    jQuery("body").addClass("trigger_product_size")
});
jQuery(".size_guide_inner .pay_pop_up_close").click(function(et) {
    et.preventDefault();
    jQuery("body").removeClass("trigger_product_size")
});

/*----------------End Product page size guide--------------------------*/
 
  
}



/*-------------------Product page swatch show ------------------*/

setTimeout(function() {
    jQuery(".prod_swa_conatiner .swatch").each(function() {
        var cthis = jQuery(this);
        var get_length_swatch = jQuery(cthis).find(".swatch-element").length;
        console.log(get_length_swatch);
        jQuery(cthis).attr("data-width", get_length_swatch)
    });
    jQuery(".prod_swa_conatiner").css({
        opacity: "1"
    })
}, 1500);
$(document).on("click", ".swatch .swatch-element", function() {
    jQuery(this).addClass("checked_sw").siblings().removeClass("checked_sw");
    var get_text = jQuery(this).attr("data-value");
    jQuery(this).parents(".swatch").find(".small_header").html(get_text);
    setTimeout(function() {
        jQuery(".prod_swa_conatiner .swatch").each(function() {
            var cthis = jQuery(this);
            var get_length_swatch = jQuery(cthis).find(".swatch-element").length;
            console.log(get_length_swatch);
            jQuery(cthis).attr("data-width", get_length_swatch)
        })
    }, 500)
});

/*-------------------End Product page swatch show ------------------*/

initCustom();



